module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = "fb15");
/******/ })
/************************************************************************/
/******/ ({

/***/ "07ad":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* eslint-disable space-infix-ops */

// The precision used to consider an ellipse as a circle
//
var epsilon = 0.0000000001;

// To convert degree in radians
//
var torad = Math.PI / 180;

// Class constructor :
//  an ellipse centred at 0 with radii rx,ry and x - axis - angle ax.
//
function Ellipse(rx, ry, ax) {
  if (!(this instanceof Ellipse)) { return new Ellipse(rx, ry, ax); }
  this.rx = rx;
  this.ry = ry;
  this.ax = ax;
}

// Apply a linear transform m to the ellipse
// m is an array representing a matrix :
//    -         -
//   | m[0] m[2] |
//   | m[1] m[3] |
//    -         -
//
Ellipse.prototype.transform = function (m) {
  // We consider the current ellipse as image of the unit circle
  // by first scale(rx,ry) and then rotate(ax) ...
  // So we apply ma =  m x rotate(ax) x scale(rx,ry) to the unit circle.
  var c = Math.cos(this.ax * torad), s = Math.sin(this.ax * torad);
  var ma = [
    this.rx * (m[0]*c + m[2]*s),
    this.rx * (m[1]*c + m[3]*s),
    this.ry * (-m[0]*s + m[2]*c),
    this.ry * (-m[1]*s + m[3]*c)
  ];

  // ma * transpose(ma) = [ J L ]
  //                      [ L K ]
  // L is calculated later (if the image is not a circle)
  var J = ma[0]*ma[0] + ma[2]*ma[2],
      K = ma[1]*ma[1] + ma[3]*ma[3];

  // the discriminant of the characteristic polynomial of ma * transpose(ma)
  var D = ((ma[0]-ma[3])*(ma[0]-ma[3]) + (ma[2]+ma[1])*(ma[2]+ma[1])) *
          ((ma[0]+ma[3])*(ma[0]+ma[3]) + (ma[2]-ma[1])*(ma[2]-ma[1]));

  // the "mean eigenvalue"
  var JK = (J + K) / 2;

  // check if the image is (almost) a circle
  if (D < epsilon * JK) {
    // if it is
    this.rx = this.ry = Math.sqrt(JK);
    this.ax = 0;
    return this;
  }

  // if it is not a circle
  var L = ma[0]*ma[1] + ma[2]*ma[3];

  D = Math.sqrt(D);

  // {l1,l2} = the two eigen values of ma * transpose(ma)
  var l1 = JK + D/2,
      l2 = JK - D/2;
  // the x - axis - rotation angle is the argument of the l1 - eigenvector
  this.ax = (Math.abs(L) < epsilon && Math.abs(l1 - K) < epsilon) ?
    90
  :
    Math.atan(Math.abs(L) > Math.abs(l1 - K) ?
      (l1 - J) / L
    :
      L / (l1 - K)
    ) * 180 / Math.PI;

  // if ax > 0 => rx = sqrt(l1), ry = sqrt(l2), else exchange axes and ax += 90
  if (this.ax >= 0) {
    // if ax in [0,90]
    this.rx = Math.sqrt(l1);
    this.ry = Math.sqrt(l2);
  } else {
    // if ax in ]-90,0[ => exchange axes
    this.ax += 90;
    this.rx = Math.sqrt(l2);
    this.ry = Math.sqrt(l1);
  }

  return this;
};

// Check if the ellipse is (almost) degenerate, i.e. rx = 0 or ry = 0
//
Ellipse.prototype.isDegenerate = function () {
  return (this.rx < epsilon * this.ry || this.ry < epsilon * this.rx);
};

module.exports = Ellipse;


/***/ }),

/***/ "08e1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var paramCounts = { a: 7, c: 6, h: 1, l: 2, m: 2, r: 4, q: 4, s: 4, t: 2, v: 1, z: 0 };

var SPECIAL_SPACES = [
  0x1680, 0x180E, 0x2000, 0x2001, 0x2002, 0x2003, 0x2004, 0x2005, 0x2006,
  0x2007, 0x2008, 0x2009, 0x200A, 0x202F, 0x205F, 0x3000, 0xFEFF
];

function isSpace(ch) {
  return (ch === 0x0A) || (ch === 0x0D) || (ch === 0x2028) || (ch === 0x2029) || // Line terminators
    // White spaces
    (ch === 0x20) || (ch === 0x09) || (ch === 0x0B) || (ch === 0x0C) || (ch === 0xA0) ||
    (ch >= 0x1680 && SPECIAL_SPACES.indexOf(ch) >= 0);
}

function isCommand(code) {
  /*eslint-disable no-bitwise*/
  switch (code | 0x20) {
    case 0x6D/* m */:
    case 0x7A/* z */:
    case 0x6C/* l */:
    case 0x68/* h */:
    case 0x76/* v */:
    case 0x63/* c */:
    case 0x73/* s */:
    case 0x71/* q */:
    case 0x74/* t */:
    case 0x61/* a */:
    case 0x72/* r */:
      return true;
  }
  return false;
}

function isDigit(code) {
  return (code >= 48 && code <= 57);   // 0..9
}

function isDigitStart(code) {
  return (code >= 48 && code <= 57) || /* 0..9 */
          code === 0x2B || /* + */
          code === 0x2D || /* - */
          code === 0x2E;   /* . */
}


function State(path) {
  this.index  = 0;
  this.path   = path;
  this.max    = path.length;
  this.result = [];
  this.param  = 0.0;
  this.err    = '';
  this.segmentStart = 0;
  this.data   = [];
}

function skipSpaces(state) {
  while (state.index < state.max && isSpace(state.path.charCodeAt(state.index))) {
    state.index++;
  }
}


function scanParam(state) {
  var start = state.index,
      index = start,
      max = state.max,
      zeroFirst = false,
      hasCeiling = false,
      hasDecimal = false,
      hasDot = false,
      ch;

  if (index >= max) {
    state.err = 'SvgPath: missed param (at pos ' + index + ')';
    return;
  }
  ch = state.path.charCodeAt(index);

  if (ch === 0x2B/* + */ || ch === 0x2D/* - */) {
    index++;
    ch = (index < max) ? state.path.charCodeAt(index) : 0;
  }

  // This logic is shamelessly borrowed from Esprima
  // https://github.com/ariya/esprimas
  //
  if (!isDigit(ch) && ch !== 0x2E/* . */) {
    state.err = 'SvgPath: param should start with 0..9 or `.` (at pos ' + index + ')';
    return;
  }

  if (ch !== 0x2E/* . */) {
    zeroFirst = (ch === 0x30/* 0 */);
    index++;

    ch = (index < max) ? state.path.charCodeAt(index) : 0;

    if (zeroFirst && index < max) {
      // decimal number starts with '0' such as '09' is illegal.
      if (ch && isDigit(ch)) {
        state.err = 'SvgPath: numbers started with `0` such as `09` are ilegal (at pos ' + start + ')';
        return;
      }
    }

    while (index < max && isDigit(state.path.charCodeAt(index))) {
      index++;
      hasCeiling = true;
    }
    ch = (index < max) ? state.path.charCodeAt(index) : 0;
  }

  if (ch === 0x2E/* . */) {
    hasDot = true;
    index++;
    while (isDigit(state.path.charCodeAt(index))) {
      index++;
      hasDecimal = true;
    }
    ch = (index < max) ? state.path.charCodeAt(index) : 0;
  }

  if (ch === 0x65/* e */ || ch === 0x45/* E */) {
    if (hasDot && !hasCeiling && !hasDecimal) {
      state.err = 'SvgPath: invalid float exponent (at pos ' + index + ')';
      return;
    }

    index++;

    ch = (index < max) ? state.path.charCodeAt(index) : 0;
    if (ch === 0x2B/* + */ || ch === 0x2D/* - */) {
      index++;
    }
    if (index < max && isDigit(state.path.charCodeAt(index))) {
      while (index < max && isDigit(state.path.charCodeAt(index))) {
        index++;
      }
    } else {
      state.err = 'SvgPath: invalid float exponent (at pos ' + index + ')';
      return;
    }
  }

  state.index = index;
  state.param = parseFloat(state.path.slice(start, index)) + 0.0;
}


function finalizeSegment(state) {
  var cmd, cmdLC;

  // Process duplicated commands (without comand name)

  // This logic is shamelessly borrowed from Raphael
  // https://github.com/DmitryBaranovskiy/raphael/
  //
  cmd   = state.path[state.segmentStart];
  cmdLC = cmd.toLowerCase();

  var params = state.data;

  if (cmdLC === 'm' && params.length > 2) {
    state.result.push([ cmd, params[0], params[1] ]);
    params = params.slice(2);
    cmdLC = 'l';
    cmd = (cmd === 'm') ? 'l' : 'L';
  }

  if (cmdLC === 'r') {
    state.result.push([ cmd ].concat(params));
  } else {

    while (params.length >= paramCounts[cmdLC]) {
      state.result.push([ cmd ].concat(params.splice(0, paramCounts[cmdLC])));
      if (!paramCounts[cmdLC]) {
        break;
      }
    }
  }
}


function scanSegment(state) {
  var max = state.max,
      cmdCode, comma_found, need_params, i;

  state.segmentStart = state.index;
  cmdCode = state.path.charCodeAt(state.index);

  if (!isCommand(cmdCode)) {
    state.err = 'SvgPath: bad command ' + state.path[state.index] + ' (at pos ' + state.index + ')';
    return;
  }

  need_params = paramCounts[state.path[state.index].toLowerCase()];

  state.index++;
  skipSpaces(state);

  state.data = [];

  if (!need_params) {
    // Z
    finalizeSegment(state);
    return;
  }

  comma_found = false;

  for (;;) {
    for (i = need_params; i > 0; i--) {
      scanParam(state);
      if (state.err.length) {
        return;
      }
      state.data.push(state.param);

      skipSpaces(state);
      comma_found = false;

      if (state.index < max && state.path.charCodeAt(state.index) === 0x2C/* , */) {
        state.index++;
        skipSpaces(state);
        comma_found = true;
      }
    }

    // after ',' param is mandatory
    if (comma_found) {
      continue;
    }

    if (state.index >= state.max) {
      break;
    }

    // Stop on next segment
    if (!isDigitStart(state.path.charCodeAt(state.index))) {
      break;
    }
  }

  finalizeSegment(state);
}


/* Returns array of segments:
 *
 * [
 *   [ command, coord1, coord2, ... ]
 * ]
 */
module.exports = function pathParse(svgPath) {
  var state = new State(svgPath);
  var max = state.max;

  skipSpaces(state);

  while (state.index < max && !state.err.length) {
    scanSegment(state);
  }

  if (state.err.length) {
    state.result = [];

  } else if (state.result.length) {

    if ('mM'.indexOf(state.result[0][0]) < 0) {
      state.err = 'SvgPath: string should start with `M` or `m`';
      state.result = [];
    } else {
      state.result[0][0] = 'M';
    }
  }

  return {
    err: state.err,
    segments: state.result
  };
};


/***/ }),

/***/ "0e2c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "208c":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LcAvatar_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("0e2c");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LcAvatar_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LcAvatar_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LcAvatar_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "22d4":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "2c60":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LcChopSimple_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("ac22");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LcChopSimple_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LcChopSimple_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LcChopSimple_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "536c":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "5eb2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LcLoadingIndicator_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("536c");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LcLoadingIndicator_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LcLoadingIndicator_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LcLoadingIndicator_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "608e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LcChopCountdown_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("22d4");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LcChopCountdown_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LcChopCountdown_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LcChopCountdown_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "71b6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// SVG Path transformations library
//
// Usage:
//
//    SvgPath('...')
//      .translate(-150, -100)
//      .scale(0.5)
//      .translate(-150, -100)
//      .toFixed(1)
//      .toString()
//




var pathParse      = __webpack_require__("08e1");
var transformParse = __webpack_require__("bc70");
var matrix         = __webpack_require__("e211");
var a2c            = __webpack_require__("d83e");
var ellipse        = __webpack_require__("07ad");


// Class constructor
//
function SvgPath(path) {
  if (!(this instanceof SvgPath)) { return new SvgPath(path); }

  var pstate = pathParse(path);

  // Array of path segments.
  // Each segment is array [command, param1, param2, ...]
  this.segments = pstate.segments;

  // Error message on parse error.
  this.err      = pstate.err;

  // Transforms stack for lazy evaluation
  this.__stack    = [];
}


SvgPath.prototype.__matrix = function (m) {
  var self = this, i;

  // Quick leave for empty matrix
  if (!m.queue.length) { return; }

  this.iterate(function (s, index, x, y) {
    var p, result, name, isRelative;

    switch (s[0]) {

      // Process 'assymetric' commands separately
      case 'v':
        p      = m.calc(0, s[1], true);
        result = (p[0] === 0) ? [ 'v', p[1] ] : [ 'l', p[0], p[1] ];
        break;

      case 'V':
        p      = m.calc(x, s[1], false);
        result = (p[0] === m.calc(x, y, false)[0]) ? [ 'V', p[1] ] : [ 'L', p[0], p[1] ];
        break;

      case 'h':
        p      = m.calc(s[1], 0, true);
        result = (p[1] === 0) ? [ 'h', p[0] ] : [ 'l', p[0], p[1] ];
        break;

      case 'H':
        p      = m.calc(s[1], y, false);
        result = (p[1] === m.calc(x, y, false)[1]) ? [ 'H', p[0] ] : [ 'L', p[0], p[1] ];
        break;

      case 'a':
      case 'A':
        // ARC is: ['A', rx, ry, x-axis-rotation, large-arc-flag, sweep-flag, x, y]

        // Drop segment if arc is empty (end point === start point)
        /*if ((s[0] === 'A' && s[6] === x && s[7] === y) ||
            (s[0] === 'a' && s[6] === 0 && s[7] === 0)) {
          return [];
        }*/

        // Transform rx, ry and the x-axis-rotation
        var ma = m.toArray();
        var e = ellipse(s[1], s[2], s[3]).transform(ma);

        // flip sweep-flag if matrix is not orientation-preserving
        if (ma[0] * ma[3] - ma[1] * ma[2] < 0) {
          s[5] = s[5] ? '0' : '1';
        }

        // Transform end point as usual (without translation for relative notation)
        p = m.calc(s[6], s[7], s[0] === 'a');

        // Empty arcs can be ignored by renderer, but should not be dropped
        // to avoid collisions with `S A S` and so on. Replace with empty line.
        if ((s[0] === 'A' && s[6] === x && s[7] === y) ||
            (s[0] === 'a' && s[6] === 0 && s[7] === 0)) {
          result = [ s[0] === 'a' ? 'l' : 'L', p[0], p[1] ];
          break;
        }

        // if the resulting ellipse is (almost) a segment ...
        if (e.isDegenerate()) {
          // replace the arc by a line
          result = [ s[0] === 'a' ? 'l' : 'L', p[0], p[1] ];
        } else {
          // if it is a real ellipse
          // s[0], s[4] and s[5] are not modified
          result = [ s[0], e.rx, e.ry, e.ax, s[4], s[5], p[0], p[1] ];
        }

        break;

      case 'm':
        // Edge case. The very first `m` should be processed as absolute, if happens.
        // Make sense for coord shift transforms.
        isRelative = index > 0;

        p = m.calc(s[1], s[2], isRelative);
        result = [ 'm', p[0], p[1] ];
        break;

      default:
        name       = s[0];
        result     = [ name ];
        isRelative = (name.toLowerCase() === name);

        // Apply transformations to the segment
        for (i = 1; i < s.length; i += 2) {
          p = m.calc(s[i], s[i + 1], isRelative);
          result.push(p[0], p[1]);
        }
    }

    self.segments[index] = result;
  }, true);
};


// Apply stacked commands
//
SvgPath.prototype.__evaluateStack = function () {
  var m, i;

  if (!this.__stack.length) { return; }

  if (this.__stack.length === 1) {
    this.__matrix(this.__stack[0]);
    this.__stack = [];
    return;
  }

  m = matrix();
  i = this.__stack.length;

  while (--i >= 0) {
    m.matrix(this.__stack[i].toArray());
  }

  this.__matrix(m);
  this.__stack = [];
};


// Convert processed SVG Path back to string
//
SvgPath.prototype.toString = function () {
  var elements = [], skipCmd, cmd;

  this.__evaluateStack();

  for (var i = 0; i < this.segments.length; i++) {
    // remove repeating commands names
    cmd = this.segments[i][0];
    skipCmd = i > 0 && cmd !== 'm' && cmd !== 'M' && cmd === this.segments[i - 1][0];
    elements = elements.concat(skipCmd ? this.segments[i].slice(1) : this.segments[i]);
  }

  return elements.join(' ')
            // Optimizations: remove spaces around commands & before `-`
            //
            // We could also remove leading zeros for `0.5`-like values,
            // but their count is too small to spend time for.
            .replace(/ ?([achlmqrstvz]) ?/gi, '$1')
            .replace(/ \-/g, '-')
            // workaround for FontForge SVG importing bug
            .replace(/zm/g, 'z m');
};


// Translate path to (x [, y])
//
SvgPath.prototype.translate = function (x, y) {
  this.__stack.push(matrix().translate(x, y || 0));
  return this;
};


// Scale path to (sx [, sy])
// sy = sx if not defined
//
SvgPath.prototype.scale = function (sx, sy) {
  this.__stack.push(matrix().scale(sx, (!sy && (sy !== 0)) ? sx : sy));
  return this;
};


// Rotate path around point (sx [, sy])
// sy = sx if not defined
//
SvgPath.prototype.rotate = function (angle, rx, ry) {
  this.__stack.push(matrix().rotate(angle, rx || 0, ry || 0));
  return this;
};


// Skew path along the X axis by `degrees` angle
//
SvgPath.prototype.skewX = function (degrees) {
  this.__stack.push(matrix().skewX(degrees));
  return this;
};


// Skew path along the Y axis by `degrees` angle
//
SvgPath.prototype.skewY = function (degrees) {
  this.__stack.push(matrix().skewY(degrees));
  return this;
};


// Apply matrix transform (array of 6 elements)
//
SvgPath.prototype.matrix = function (m) {
  this.__stack.push(matrix().matrix(m));
  return this;
};


// Transform path according to "transform" attr of SVG spec
//
SvgPath.prototype.transform = function (transformString) {
  if (!transformString.trim()) {
    return this;
  }
  this.__stack.push(transformParse(transformString));
  return this;
};


// Round coords with given decimal precition.
// 0 by default (to integers)
//
SvgPath.prototype.round = function (d) {
  var contourStartDeltaX = 0, contourStartDeltaY = 0, deltaX = 0, deltaY = 0, l;

  d = d || 0;

  this.__evaluateStack();

  this.segments.forEach(function (s) {
    var isRelative = (s[0].toLowerCase() === s[0]);

    switch (s[0]) {
      case 'H':
      case 'h':
        if (isRelative) { s[1] += deltaX; }
        deltaX = s[1] - s[1].toFixed(d);
        s[1] = +s[1].toFixed(d);
        return;

      case 'V':
      case 'v':
        if (isRelative) { s[1] += deltaY; }
        deltaY = s[1] - s[1].toFixed(d);
        s[1] = +s[1].toFixed(d);
        return;

      case 'Z':
      case 'z':
        deltaX = contourStartDeltaX;
        deltaY = contourStartDeltaY;
        return;

      case 'M':
      case 'm':
        if (isRelative) {
          s[1] += deltaX;
          s[2] += deltaY;
        }

        deltaX = s[1] - s[1].toFixed(d);
        deltaY = s[2] - s[2].toFixed(d);

        contourStartDeltaX = deltaX;
        contourStartDeltaY = deltaY;

        s[1] = +s[1].toFixed(d);
        s[2] = +s[2].toFixed(d);
        return;

      case 'A':
      case 'a':
        // [cmd, rx, ry, x-axis-rotation, large-arc-flag, sweep-flag, x, y]
        if (isRelative) {
          s[6] += deltaX;
          s[7] += deltaY;
        }

        deltaX = s[6] - s[6].toFixed(d);
        deltaY = s[7] - s[7].toFixed(d);

        s[1] = +s[1].toFixed(d);
        s[2] = +s[2].toFixed(d);
        s[3] = +s[3].toFixed(d + 2); // better precision for rotation
        s[6] = +s[6].toFixed(d);
        s[7] = +s[7].toFixed(d);
        return;

      default:
        // a c l q s t
        l = s.length;

        if (isRelative) {
          s[l - 2] += deltaX;
          s[l - 1] += deltaY;
        }

        deltaX = s[l - 2] - s[l - 2].toFixed(d);
        deltaY = s[l - 1] - s[l - 1].toFixed(d);

        s.forEach(function (val, i) {
          if (!i) { return; }
          s[i] = +s[i].toFixed(d);
        });
        return;
    }
  });

  return this;
};


// Apply iterator function to all segments. If function returns result,
// current segment will be replaced to array of returned segments.
// If empty array is returned, current regment will be deleted.
//
SvgPath.prototype.iterate = function (iterator, keepLazyStack) {
  var segments = this.segments,
      replacements = {},
      needReplace = false,
      lastX = 0,
      lastY = 0,
      countourStartX = 0,
      countourStartY = 0;
  var i, j, newSegments;

  if (!keepLazyStack) {
    this.__evaluateStack();
  }

  segments.forEach(function (s, index) {

    var res = iterator(s, index, lastX, lastY);

    if (Array.isArray(res)) {
      replacements[index] = res;
      needReplace = true;
    }

    var isRelative = (s[0] === s[0].toLowerCase());

    // calculate absolute X and Y
    switch (s[0]) {
      case 'm':
      case 'M':
        lastX = s[1] + (isRelative ? lastX : 0);
        lastY = s[2] + (isRelative ? lastY : 0);
        countourStartX = lastX;
        countourStartY = lastY;
        return;

      case 'h':
      case 'H':
        lastX = s[1] + (isRelative ? lastX : 0);
        return;

      case 'v':
      case 'V':
        lastY = s[1] + (isRelative ? lastY : 0);
        return;

      case 'z':
      case 'Z':
        // That make sence for multiple contours
        lastX = countourStartX;
        lastY = countourStartY;
        return;

      default:
        lastX = s[s.length - 2] + (isRelative ? lastX : 0);
        lastY = s[s.length - 1] + (isRelative ? lastY : 0);
    }
  });

  // Replace segments if iterator return results

  if (!needReplace) { return this; }

  newSegments = [];

  for (i = 0; i < segments.length; i++) {
    if (typeof replacements[i] !== 'undefined') {
      for (j = 0; j < replacements[i].length; j++) {
        newSegments.push(replacements[i][j]);
      }
    } else {
      newSegments.push(segments[i]);
    }
  }

  this.segments = newSegments;

  return this;
};


// Converts segments from relative to absolute
//
SvgPath.prototype.abs = function () {

  this.iterate(function (s, index, x, y) {
    var name = s[0],
        nameUC = name.toUpperCase(),
        i;

    // Skip absolute commands
    if (name === nameUC) { return; }

    s[0] = nameUC;

    switch (name) {
      case 'v':
        // v has shifted coords parity
        s[1] += y;
        return;

      case 'a':
        // ARC is: ['A', rx, ry, x-axis-rotation, large-arc-flag, sweep-flag, x, y]
        // touch x, y only
        s[6] += x;
        s[7] += y;
        return;

      default:
        for (i = 1; i < s.length; i++) {
          s[i] += i % 2 ? x : y; // odd values are X, even - Y
        }
    }
  }, true);

  return this;
};


// Converts segments from absolute to relative
//
SvgPath.prototype.rel = function () {

  this.iterate(function (s, index, x, y) {
    var name = s[0],
        nameLC = name.toLowerCase(),
        i;

    // Skip relative commands
    if (name === nameLC) { return; }

    // Don't touch the first M to avoid potential confusions.
    if (index === 0 && name === 'M') { return; }

    s[0] = nameLC;

    switch (name) {
      case 'V':
        // V has shifted coords parity
        s[1] -= y;
        return;

      case 'A':
        // ARC is: ['A', rx, ry, x-axis-rotation, large-arc-flag, sweep-flag, x, y]
        // touch x, y only
        s[6] -= x;
        s[7] -= y;
        return;

      default:
        for (i = 1; i < s.length; i++) {
          s[i] -= i % 2 ? x : y; // odd values are X, even - Y
        }
    }
  }, true);

  return this;
};


// Converts arcs to cubic bézier curves
//
SvgPath.prototype.unarc = function () {
  this.iterate(function (s, index, x, y) {
    var new_segments, nextX, nextY, result = [], name = s[0];

    // Skip anything except arcs
    if (name !== 'A' && name !== 'a') { return null; }

    if (name === 'a') {
      // convert relative arc coordinates to absolute
      nextX = x + s[6];
      nextY = y + s[7];
    } else {
      nextX = s[6];
      nextY = s[7];
    }

    new_segments = a2c(x, y, nextX, nextY, s[4], s[5], s[1], s[2], s[3]);

    // Degenerated arcs can be ignored by renderer, but should not be dropped
    // to avoid collisions with `S A S` and so on. Replace with empty line.
    if (new_segments.length === 0) {
      return [ [ s[0] === 'a' ? 'l' : 'L', s[6], s[7] ] ];
    }

    new_segments.forEach(function (s) {
      result.push([ 'C', s[2], s[3], s[4], s[5], s[6], s[7] ]);
    });

    return result;
  });

  return this;
};


// Converts smooth curves (with missed control point) to generic curves
//
SvgPath.prototype.unshort = function () {
  var segments = this.segments;
  var prevControlX, prevControlY, prevSegment;
  var curControlX, curControlY;

  // TODO: add lazy evaluation flag when relative commands supported

  this.iterate(function (s, idx, x, y) {
    var name = s[0], nameUC = name.toUpperCase(), isRelative;

    // First command MUST be M|m, it's safe to skip.
    // Protect from access to [-1] for sure.
    if (!idx) { return; }

    if (nameUC === 'T') { // quadratic curve
      isRelative = (name === 't');

      prevSegment = segments[idx - 1];

      if (prevSegment[0] === 'Q') {
        prevControlX = prevSegment[1] - x;
        prevControlY = prevSegment[2] - y;
      } else if (prevSegment[0] === 'q') {
        prevControlX = prevSegment[1] - prevSegment[3];
        prevControlY = prevSegment[2] - prevSegment[4];
      } else {
        prevControlX = 0;
        prevControlY = 0;
      }

      curControlX = -prevControlX;
      curControlY = -prevControlY;

      if (!isRelative) {
        curControlX += x;
        curControlY += y;
      }

      segments[idx] = [
        isRelative ? 'q' : 'Q',
        curControlX, curControlY,
        s[1], s[2]
      ];

    } else if (nameUC === 'S') { // cubic curve
      isRelative = (name === 's');

      prevSegment = segments[idx - 1];

      if (prevSegment[0] === 'C') {
        prevControlX = prevSegment[3] - x;
        prevControlY = prevSegment[4] - y;
      } else if (prevSegment[0] === 'c') {
        prevControlX = prevSegment[3] - prevSegment[5];
        prevControlY = prevSegment[4] - prevSegment[6];
      } else {
        prevControlX = 0;
        prevControlY = 0;
      }

      curControlX = -prevControlX;
      curControlY = -prevControlY;

      if (!isRelative) {
        curControlX += x;
        curControlY += y;
      }

      segments[idx] = [
        isRelative ? 'c' : 'C',
        curControlX, curControlY,
        s[1], s[2], s[3], s[4]
      ];
    }
  });

  return this;
};


module.exports = SvgPath;


/***/ }),

/***/ "7507":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LcChopCivicLiker_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("bb28");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LcChopCivicLiker_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LcChopCivicLiker_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LcChopCivicLiker_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "84fa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__("71b6");


/***/ }),

/***/ "8971":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "9536":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "a41e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LcChopCivicLikerRect_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("8971");
/* harmony import */ var _node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LcChopCivicLikerRect_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LcChopCivicLikerRect_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0__);
/* unused harmony reexport * */
 /* unused harmony default export */ var _unused_webpack_default_export = (_node_modules_mini_css_extract_plugin_dist_loader_js_ref_8_oneOf_1_0_node_modules_css_loader_index_js_ref_8_oneOf_1_1_node_modules_vue_loader_lib_loaders_stylePostLoader_js_node_modules_postcss_loader_src_index_js_ref_8_oneOf_1_2_node_modules_sass_loader_lib_loader_js_ref_8_oneOf_1_3_node_modules_cache_loader_dist_cjs_js_ref_0_0_node_modules_vue_loader_lib_index_js_vue_loader_options_LcChopCivicLikerRect_vue_vue_type_style_index_0_lang_scss___WEBPACK_IMPORTED_MODULE_0___default.a); 

/***/ }),

/***/ "ac22":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "bb28":
/***/ (function(module, exports, __webpack_require__) {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ "bc70":
/***/ (function(module, exports, __webpack_require__) {

"use strict";



var Matrix = __webpack_require__("e211");

var operations = {
  matrix: true,
  scale: true,
  rotate: true,
  translate: true,
  skewX: true,
  skewY: true
};

var CMD_SPLIT_RE    = /\s*(matrix|translate|scale|rotate|skewX|skewY)\s*\(\s*(.+?)\s*\)[\s,]*/;
var PARAMS_SPLIT_RE = /[\s,]+/;


module.exports = function transformParse(transformString) {
  var matrix = new Matrix();
  var cmd, params;

  // Split value into ['', 'translate', '10 50', '', 'scale', '2', '', 'rotate',  '-45', '']
  transformString.split(CMD_SPLIT_RE).forEach(function (item) {

    // Skip empty elements
    if (!item.length) { return; }

    // remember operation
    if (typeof operations[item] !== 'undefined') {
      cmd = item;
      return;
    }

    // extract params & att operation to matrix
    params = item.split(PARAMS_SPLIT_RE).map(function (i) {
      return +i || 0;
    });

    // If params count is not correct - ignore command
    switch (cmd) {
      case 'matrix':
        if (params.length === 6) {
          matrix.matrix(params);
        }
        return;

      case 'scale':
        if (params.length === 1) {
          matrix.scale(params[0], params[0]);
        } else if (params.length === 2) {
          matrix.scale(params[0], params[1]);
        }
        return;

      case 'rotate':
        if (params.length === 1) {
          matrix.rotate(params[0], 0, 0);
        } else if (params.length === 3) {
          matrix.rotate(params[0], params[1], params[2]);
        }
        return;

      case 'translate':
        if (params.length === 1) {
          matrix.translate(params[0], 0);
        } else if (params.length === 2) {
          matrix.translate(params[0], params[1]);
        }
        return;

      case 'skewX':
        if (params.length === 1) {
          matrix.skewX(params[0]);
        }
        return;

      case 'skewY':
        if (params.length === 1) {
          matrix.skewY(params[0]);
        }
        return;
    }
  });

  return matrix;
};


/***/ }),

/***/ "d83e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// Convert an arc to a sequence of cubic bézier curves
//



var TAU = Math.PI * 2;


/* eslint-disable space-infix-ops */

// Calculate an angle between two vectors
//
function vector_angle(ux, uy, vx, vy) {
  var sign = (ux * vy - uy * vx < 0) ? -1 : 1;
  var umag = Math.sqrt(ux * ux + uy * uy);
  var vmag = Math.sqrt(ux * ux + uy * uy);
  var dot  = ux * vx + uy * vy;
  var div  = dot / (umag * vmag);

  // rounding errors, e.g. -1.0000000000000002 can screw up this
  if (div >  1.0) { div =  1.0; }
  if (div < -1.0) { div = -1.0; }

  return sign * Math.acos(div);
}


// Convert from endpoint to center parameterization,
// see http://www.w3.org/TR/SVG11/implnote.html#ArcImplementationNotes
//
// Return [cx, cy, theta1, delta_theta]
//
function get_arc_center(x1, y1, x2, y2, fa, fs, rx, ry, sin_phi, cos_phi) {
  // Step 1.
  //
  // Moving an ellipse so origin will be the middlepoint between our two
  // points. After that, rotate it to line up ellipse axes with coordinate
  // axes.
  //
  var x1p =  cos_phi*(x1-x2)/2 + sin_phi*(y1-y2)/2;
  var y1p = -sin_phi*(x1-x2)/2 + cos_phi*(y1-y2)/2;

  var rx_sq  =  rx * rx;
  var ry_sq  =  ry * ry;
  var x1p_sq = x1p * x1p;
  var y1p_sq = y1p * y1p;

  // Step 2.
  //
  // Compute coordinates of the centre of this ellipse (cx', cy')
  // in the new coordinate system.
  //
  var radicant = (rx_sq * ry_sq) - (rx_sq * y1p_sq) - (ry_sq * x1p_sq);

  if (radicant < 0) {
    // due to rounding errors it might be e.g. -1.3877787807814457e-17
    radicant = 0;
  }

  radicant /=   (rx_sq * y1p_sq) + (ry_sq * x1p_sq);
  radicant = Math.sqrt(radicant) * (fa === fs ? -1 : 1);

  var cxp = radicant *  rx/ry * y1p;
  var cyp = radicant * -ry/rx * x1p;

  // Step 3.
  //
  // Transform back to get centre coordinates (cx, cy) in the original
  // coordinate system.
  //
  var cx = cos_phi*cxp - sin_phi*cyp + (x1+x2)/2;
  var cy = sin_phi*cxp + cos_phi*cyp + (y1+y2)/2;

  // Step 4.
  //
  // Compute angles (theta1, delta_theta).
  //
  var v1x =  (x1p - cxp) / rx;
  var v1y =  (y1p - cyp) / ry;
  var v2x = (-x1p - cxp) / rx;
  var v2y = (-y1p - cyp) / ry;

  var theta1 = vector_angle(1, 0, v1x, v1y);
  var delta_theta = vector_angle(v1x, v1y, v2x, v2y);

  if (fs === 0 && delta_theta > 0) {
    delta_theta -= TAU;
  }
  if (fs === 1 && delta_theta < 0) {
    delta_theta += TAU;
  }

  return [ cx, cy, theta1, delta_theta ];
}

//
// Approximate one unit arc segment with bézier curves,
// see http://math.stackexchange.com/questions/873224
//
function approximate_unit_arc(theta1, delta_theta) {
  var alpha = 4/3 * Math.tan(delta_theta/4);

  var x1 = Math.cos(theta1);
  var y1 = Math.sin(theta1);
  var x2 = Math.cos(theta1 + delta_theta);
  var y2 = Math.sin(theta1 + delta_theta);

  return [ x1, y1, x1 - y1*alpha, y1 + x1*alpha, x2 + y2*alpha, y2 - x2*alpha, x2, y2 ];
}

module.exports = function a2c(x1, y1, x2, y2, fa, fs, rx, ry, phi) {
  var sin_phi = Math.sin(phi * TAU / 360);
  var cos_phi = Math.cos(phi * TAU / 360);

  // Make sure radii are valid
  //
  var x1p =  cos_phi*(x1-x2)/2 + sin_phi*(y1-y2)/2;
  var y1p = -sin_phi*(x1-x2)/2 + cos_phi*(y1-y2)/2;

  if (x1p === 0 && y1p === 0) {
    // we're asked to draw line to itself
    return [];
  }

  if (rx === 0 || ry === 0) {
    // one of the radii is zero
    return [];
  }


  // Compensate out-of-range radii
  //
  rx = Math.abs(rx);
  ry = Math.abs(ry);

  var lambda = (x1p * x1p) / (rx * rx) + (y1p * y1p) / (ry * ry);
  if (lambda > 1) {
    rx *= Math.sqrt(lambda);
    ry *= Math.sqrt(lambda);
  }


  // Get center parameters (cx, cy, theta1, delta_theta)
  //
  var cc = get_arc_center(x1, y1, x2, y2, fa, fs, rx, ry, sin_phi, cos_phi);

  var result = [];
  var theta1 = cc[2];
  var delta_theta = cc[3];

  // Split an arc to multiple segments, so each segment
  // will be less than τ/4 (= 90°)
  //
  var segments = Math.max(Math.ceil(Math.abs(delta_theta) / (TAU / 4)), 1);
  delta_theta /= segments;

  for (var i = 0; i < segments; i++) {
    result.push(approximate_unit_arc(theta1, delta_theta));
    theta1 += delta_theta;
  }

  // We have a bezier approximation of a unit circle,
  // now need to transform back to the original ellipse
  //
  return result.map(function (curve) {
    for (var i = 0; i < curve.length; i += 2) {
      var x = curve[i + 0];
      var y = curve[i + 1];

      // scale
      x *= rx;
      y *= ry;

      // rotate
      var xp = cos_phi*x - sin_phi*y;
      var yp = sin_phi*x + cos_phi*y;

      // translate
      curve[i + 0] = xp + cc[0];
      curve[i + 1] = yp + cc[1];
    }

    return curve;
  });
};


/***/ }),

/***/ "e211":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// combine 2 matrixes
// m1, m2 - [a, b, c, d, e, g]
//
function combine(m1, m2) {
  return [
    m1[0] * m2[0] + m1[2] * m2[1],
    m1[1] * m2[0] + m1[3] * m2[1],
    m1[0] * m2[2] + m1[2] * m2[3],
    m1[1] * m2[2] + m1[3] * m2[3],
    m1[0] * m2[4] + m1[2] * m2[5] + m1[4],
    m1[1] * m2[4] + m1[3] * m2[5] + m1[5]
  ];
}


function Matrix() {
  if (!(this instanceof Matrix)) { return new Matrix(); }
  this.queue = [];   // list of matrixes to apply
  this.cache = null; // combined matrix cache
}


Matrix.prototype.matrix = function (m) {
  if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1 && m[4] === 0 && m[5] === 0) {
    return this;
  }
  this.cache = null;
  this.queue.push(m);
  return this;
};


Matrix.prototype.translate = function (tx, ty) {
  if (tx !== 0 || ty !== 0) {
    this.cache = null;
    this.queue.push([ 1, 0, 0, 1, tx, ty ]);
  }
  return this;
};


Matrix.prototype.scale = function (sx, sy) {
  if (sx !== 1 || sy !== 1) {
    this.cache = null;
    this.queue.push([ sx, 0, 0, sy, 0, 0 ]);
  }
  return this;
};


Matrix.prototype.rotate = function (angle, rx, ry) {
  var rad, cos, sin;

  if (angle !== 0) {
    this.translate(rx, ry);

    rad = angle * Math.PI / 180;
    cos = Math.cos(rad);
    sin = Math.sin(rad);

    this.queue.push([ cos, sin, -sin, cos, 0, 0 ]);
    this.cache = null;

    this.translate(-rx, -ry);
  }
  return this;
};


Matrix.prototype.skewX = function (angle) {
  if (angle !== 0) {
    this.cache = null;
    this.queue.push([ 1, 0, Math.tan(angle * Math.PI / 180), 1, 0, 0 ]);
  }
  return this;
};


Matrix.prototype.skewY = function (angle) {
  if (angle !== 0) {
    this.cache = null;
    this.queue.push([ 1, Math.tan(angle * Math.PI / 180), 0, 1, 0, 0 ]);
  }
  return this;
};


// Flatten queue
//
Matrix.prototype.toArray = function () {
  if (this.cache) {
    return this.cache;
  }

  if (!this.queue.length) {
    this.cache = [ 1, 0, 0, 1, 0, 0 ];
    return this.cache;
  }

  this.cache = this.queue[0];

  if (this.queue.length === 1) {
    return this.cache;
  }

  for (var i = 1; i < this.queue.length; i++) {
    this.cache = combine(this.cache, this.queue[i]);
  }

  return this.cache;
};


// Apply list of matrixes to (x,y) point.
// If `isRelative` set, `translate` component of matrix will be skipped
//
Matrix.prototype.calc = function (x, y, isRelative) {
  var m;

  // Don't change point on empty transforms queue
  if (!this.queue.length) { return [ x, y ]; }

  // Calculate final matrix, if not exists
  //
  // NB. if you deside to apply transforms to point one-by-one,
  // they should be taken in reverse order

  if (!this.cache) {
    this.cache = this.toArray();
  }

  m = this.cache;

  // Apply matrix to point
  return [
    x * m[0] + y * m[2] + (isRelative ? 0 : m[4]),
    x * m[1] + y * m[3] + (isRelative ? 0 : m[5])
  ];
};


module.exports = Matrix;


/***/ }),

/***/ "f6fd":
/***/ (function(module, exports) {

// document.currentScript polyfill by Adam Miller

// MIT license

(function(document){
  var currentScript = "currentScript",
      scripts = document.getElementsByTagName('script'); // Live NodeList collection

  // If browser needs currentScript polyfill, add get currentScript() to the document object
  if (!(currentScript in document)) {
    Object.defineProperty(document, currentScript, {
      get: function(){

        // IE 6-10 supports script readyState
        // IE 10+ support stack trace
        try { throw new Error(); }
        catch (err) {

          // Find the second match for the "at" string to get file src url from stack.
          // Specifically works with the format of stack traces in IE.
          var i, res = ((/.*at [^\(]*\((.*):.+:.+\)$/ig).exec(err.stack) || [false])[1];

          // For all scripts on the page, if src matches or if ready state is interactive, return the script tag
          for(i in scripts){
            if(scripts[i].src == res || scripts[i].readyState == "interactive"){
              return scripts[i];
            }
          }

          // If no match, return null
          return null;
        }
      }
    });
  }
})(document);


/***/ }),

/***/ "fb15":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  if (true) {
    __webpack_require__("f6fd")
  }

  var i
  if ((i = window.document.currentScript) && (i = i.src.match(/(.+\/)[^/]+\.js(\?.*)?$/))) {
    __webpack_require__.p = i[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./src/assets/css/index.scss
var css = __webpack_require__("9536");

// CONCATENATED MODULE: ./src/components/LikeCoinUI/index.js
var LikeCoinUI = {
  install: function install(Vue) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    // Register components
    if (options.components) {
      for (var key in options.components) {
        var component = options.components[key];

        if (component) {
          Vue.component(key, component);
        }
      }
    }
  }
};
/* harmony default export */ var components_LikeCoinUI = (LikeCoinUI);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"27a05820-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/LcAvatar/LcAvatar.vue?vue&type=template&id=fb96acf0&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.rootClass},[_c('div',{staticClass:"lc-avatar__content",style:(_vm.contentStyle)},[_c('div',{staticClass:"lc-avatar__content__halo",on:{"click":_vm.onClickHalo}},[(_vm.isSmall && _vm.halo !== 'none')?_c('civic-liker-small-halo'):(_vm.isCivicLiker)?_c('civic-liker-halo'):(_vm.isCivicLikerTrial)?_c('civic-liker-trial-halo'):_vm._e()],1),_c('div',{staticClass:"lc-avatar__content__image",on:{"click":_vm.onClick}},[_c('img',_vm._b({},'img',_vm.$attrs,false))])])])}
var staticRenderFns = []


// CONCATENATED MODULE: ./src/components/LcAvatar/LcAvatar.vue?vue&type=template&id=fb96acf0&

// CONCATENATED MODULE: ./src/assets/avatar/halo/civic-liker.svg?inline

      /* harmony default export */ var civic_likerinline = ({
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 152 152","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M30.5 15.5c.9-.7 1.7-.9 2.7-.8.1 0 .2.1.2.2l-.1 1.2c0 .1-.1.2-.2.2-.5 0-1.1.1-1.5.5-1 .8-1.1 2.1-.3 3.1.7 1 2.1 1.2 3.1.5.4-.3.7-.8.8-1.3 0-.1.1-.2.2-.2l1.2.2c.1 0 .2.1.2.2-.2 1-.7 1.9-1.5 2.5-1.7 1.3-4.2 1-5.5-.7-1.3-1.8-1-4.3.7-5.6m6.7-4.2c-.1-.1 0-.2.1-.3l1.1-.7c.1-.1.2 0 .3.1l3.6 6.2c.1.1 0 .2-.1.3l-1.1.7c-.1.1-.2 0-.3-.1.1.1-3.6-6.2-3.6-6.2zm6-3.1c-.1-.1-.1-.3.1-.3l1.3-.6h.2l3.2 3h.1l.1-4.4c0-.1.1-.1.1-.2l1.3-.6c.2-.1.3 0 .3.2l-.3 8.1c0 .1-.1.2-.1.2h-.3l-6-5.4zm11.3-4.4c0-.1 0-.2.1-.3l1.3-.4c.1 0 .2 0 .3.1l2 7c0 .1 0 .2-.1.3l-1.3.4c-.1 0-.2 0-.3-.1 0-.1-2-7-2-7zm10.7-2.7c1.1-.2 1.9.1 2.8.6.1.1.1.2.1.3l-.7 1c-.1.1-.2.1-.3 0-.5-.3-1-.4-1.5-.3-1.2.2-2 1.3-1.8 2.5s1.2 2.1 2.4 1.9c.5-.1 1-.3 1.4-.7.2-.1.2-.1.4 0l1 .8c.1.1.1.2 0 .3-.6.8-1.5 1.3-2.5 1.4-2.1.3-4.1-1.1-4.5-3.3-.5-2.1 1-4.2 3.2-4.5m9.6 4.2c0-.7.5-1.2 1.1-1.2.7 0 1.2.5 1.2 1.2 0 .6-.5 1.1-1.2 1.1-.6.1-1.1-.4-1.1-1.1m9.7-4.2c0-.1.1-.2.2-.2l1.3.2c.1 0 .2.1.2.2l-.8 5.8 2.6.4c.1 0 .2.1.2.2L88 8.9c0 .1-.1.2-.2.2l-4.1-.6c-.1 0-.2-.1-.2-.2l1-7.2zm9.4 1.7c0-.1.1-.2.3-.2l1.3.3c.1 0 .2.1.1.3l-1.8 7c0 .1-.1.2-.3.1l-1.3-.3c-.1 0-.2-.1-.2-.3.1.1 1.9-6.9 1.9-6.9zm7.2 2.2c.1-.1.2-.2.3-.1l1.2.5c.1.1.2.2.1.3l-1.1 2.7 3.4-1.9h.2l1.3.5c.2.1.2.3 0 .4l-3.6 2 1.3 4.4c0 .1-.1.3-.2.3h-.2l-1.4-.6c-.1 0-.1-.1-.2-.1l-1-4.1-1.2 3c-.1.1-.2.2-.3.1l-1.2-.5c-.1-.1-.2-.2-.1-.3.2 0 2.8-6.6 2.7-6.6zm10.5 4.6c.1-.1.2-.1.3-.1l3.9 2.3c.1.1.1.2.1.3l-.6 1c-.1.1-.2.1-.3.1l-2.6-1.5-.7 1.2 2.2 1.2c.1.1.1.2.1.3l-.6 1c-.1.1-.2.1-.3.1l-2.2-1.2-.7 1.3 2.6 1.5c.1.1.1.2.1.3l-.6 1c-.1.1-.2.1-.3.1l-3.9-2.3c-.1-.1-.1-.2-.1-.3l3.6-6.3zm9.6 10c.3.3.9.2 1.2-.2s.2-.9-.1-1.2l-1.3-1-1.1 1.3 1.3 1.1zm-.7-4.4c.1-.1.2-.1.3 0l2.6 2c1 .8 1.2 2.3.4 3.3-.6.8-1.6 1-2.6.7l-.5 3.1c0 .2-.2.2-.3.1l-1.1-.9c-.1 0-.1-.1-.1-.2l.7-3.2-.6-.5-1.7 2.2c-.1.1-.2.1-.3 0l-1-.8c-.1-.1-.1-.2 0-.3-.3.2 4.2-5.5 4.2-5.5zM15.4 38.3c-.8 0-1.5-.7-1.5-1.5 0-.3.1-.6.2-.8 2.4-3.7 5.1-7.1 8.1-10.3.6-.6 1.5-.6 2.1-.1.6.6.6 1.5.1 2.1-2.9 3.1-5.5 6.4-7.7 9.9-.4.4-.8.7-1.3.7M5.8 60.2c-.8 0-1.5-.7-1.5-1.5v-.4c1.2-5 3-9.8 5.2-14.4.4-.7 1.3-1 2-.7.7.4 1 1.2.7 2-2.1 4.4-3.8 9-5 13.8-.1.8-.7 1.2-1.4 1.2m18.8 68c-.4 0-.8-.2-1.1-.4-13.7-14-21.3-32.4-21.3-51.7 0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5c0 18.6 7.3 36.2 20.5 49.6.6.6.6 1.5 0 2.1-.3.3-.7.4-1.1.4m51.3 21.5c-15.4 0-30.2-4.8-42.8-13.9-.7-.5-.9-1.4-.4-2.1s1.4-.9 2.1-.4h.1C47 142 61.2 146.6 76 146.6c18.6 0 36.2-7.3 49.6-20.5.6-.6 1.5-.6 2.1 0s.6 1.5 0 2.1c-14 14-32.4 21.5-51.8 21.5m-46-16.8c-.3 0-.7-.1-1-.3-.5-.4-1-.8-1.4-1.2-.6-.6-.6-1.5-.1-2.1s1.4-.6 2.1-.1c.5.4.9.8 1.4 1.2.6.5.7 1.5.2 2.1-.3.2-.7.4-1.2.4m106.7-16.2c-.8 0-1.5-.7-1.5-1.5 0-.3.1-.6.2-.8 7.5-11.5 11.4-24.7 11.4-38.3 0-10-2.1-19.9-6.2-29-.3-.8 0-1.6.8-2 .8-.3 1.6 0 2 .8 4.3 9.5 6.5 19.8 6.5 30.3 0 14.2-4.1 28-11.9 40-.4.2-.8.5-1.3.5m-.7-79.5c-.5 0-1-.2-1.2-.7-1.9-2.9-4.1-5.6-6.4-8.2-.5-.6-.5-1.6.2-2.1.6-.5 1.5-.5 2.1.1 2.4 2.7 4.7 5.5 6.7 8.5.5.7.3 1.6-.4 2.1-.4.2-.7.3-1 .3"}})])
      }
    
      });
    
// CONCATENATED MODULE: ./src/assets/avatar/halo/civic-liker_small.svg?inline

      /* harmony default export */ var civic_liker_smallinline = ({
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 55 55","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M1.524 21.701a.738.738 0 0 1-.717-.917 27.464 27.464 0 0 1 1.93-5.333.738.738 0 1 1 1.33.643 26.005 26.005 0 0 0-1.827 5.047.738.738 0 0 1-.716.56m6.748 24.914a.737.737 0 0 1-.53-.225C2.75 41.232 0 34.481 0 27.38a.738.738 0 0 1 1.476 0c0 6.716 2.602 13.102 7.326 17.983a.738.738 0 0 1-.53 1.252m2.112 1.962a.734.734 0 0 1-.473-.172c-.18-.15-.36-.304-.536-.459a.738.738 0 1 1 .975-1.108c.167.146.336.291.507.434a.738.738 0 0 1-.473 1.305m39.363-6.009a.739.739 0 0 1-.618-1.141 25.675 25.675 0 0 0 4.186-14.047c0-3.69-.77-7.267-2.287-10.636a.738.738 0 1 1 1.347-.607A27.204 27.204 0 0 1 54.79 27.38c0 5.274-1.53 10.41-4.425 14.853a.738.738 0 0 1-.62.335M27.396 54.776c-5.66 0-11.11-1.743-15.758-5.04a.738.738 0 1 1 .854-1.205c4.398 3.12 9.551 4.768 14.904 4.768 6.822 0 13.282-2.673 18.19-7.528a.738.738 0 0 1 1.038 1.05c-5.186 5.13-12.014 7.955-19.228 7.955m22.121-41.527a.737.737 0 0 1-.613-.327 25.756 25.756 0 0 0-7.392-7.279.739.739 0 0 1 .804-1.238 27.231 27.231 0 0 1 7.813 7.694.738.738 0 0 1-.612 1.15m-44.427.287a.738.738 0 0 1-.617-1.143 27.56 27.56 0 0 1 10.115-9.22A27.446 27.446 0 0 1 27.396 0c4.338 0 8.487.985 12.332 2.927a.738.738 0 1 1-.666 1.318 25.637 25.637 0 0 0-11.666-2.768 25.966 25.966 0 0 0-12.117 3.001 26.077 26.077 0 0 0-9.57 8.724.738.738 0 0 1-.618.334","fill-rule":"evenodd"}})])
      }
    
      });
    
// CONCATENATED MODULE: ./src/assets/avatar/halo/civic-liker_trial.svg?inline

      /* harmony default export */ var civic_liker_trialinline = ({
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 152 152","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M54.6 4.7l1.5-.4 1.5 5.7c0 .1.1.2.3.1l1.3-.3c.1 0 .2-.1.1-.3l-1.5-5.7 1.5-.4c.1 0 .2-.1.1-.3l-.3-1.2c0-.1-.1-.2-.3-.1L54.1 3c-.1 0-.2.1-.1.3l.3 1.2c.1.2.2.3.3.2M67.7 2c.5-.1.9.3.9.7.1.5-.3.9-.7 1l-1.6.2-.2-1.7 1.6-.2zm-2.3 6.5l1.3-.2c.1 0 .2-.1.2-.2l-.3-2.8.7-.1L69 7.9s.1.1.2.1l1.4-.2c.2 0 .2-.2.1-.3L69 4.9c.9-.5 1.5-1.4 1.3-2.4C70.1 1.2 69 .3 67.7.4l-3.2.4c-.1 0-.2.1-.2.2l.9 7.2c-.1.2 0 .3.2.3zm10.3-.8H77c.1 0 .2-.1.2-.2l.2-7.3c0-.1-.1-.2-.2-.2h-1.3c-.1 0-.2.1-.2.2l-.2 7.3c0 .1.1.2.2.2m9.6-3.8l.6 1.9-1.6-.2 1-1.7zm-4 3.9l1.2.2c.2 0 .3-.1.4-.2l.5-.8 2.9.4.3.9c.1.2.1.3.3.3l1.2.2c.2 0 .3-.1.2-.3L86 .7c0-.1-.1-.1-.2-.1h-.1c-.1 0-.2 0-.2.1l-4.3 6.9c-.1 0 0 .2.1.2zm11.1 1.9l4 1.1c.1 0 .2 0 .3-.1l.3-1.2c0-.1 0-.2-.1-.3l-2.5-.7 1.5-5.7c0-.1 0-.2-.1-.3l-1.3-.3c-.1 0-.2 0-.3.1l-1.9 7c0 .3 0 .4.1.4M5.5 60.1c.8.2 1.6-.3 1.8-1.1 1.2-4.8 2.9-9.4 5-13.8.4-.8 0-1.7-.7-2s-1.6 0-2 .7c-2.2 4.6-4 9.5-5.2 14.4-.1.8.3 1.6 1.1 1.8m-.2 16c0-.8-.7-1.5-1.5-1.5s-1.5.7-1.5 1.5c0 19.5 7.6 38 21.4 52 .3.3.7.4 1.1.4.8 0 1.5-.7 1.5-1.5 0-.4-.2-.8-.4-1.1C12.6 112.5 5.3 94.8 5.3 76.1m120.3 50.5c-13.4 13.3-31 20.7-49.6 20.7-14.8 0-29-4.6-41.1-13.4-.7-.5-1.6-.4-2.1.3s-.4 1.6.3 2.1h.1c12.6 9.1 27.4 13.9 42.8 13.9 19.4 0 37.8-7.6 51.7-21.5.6-.6.5-1.6-.1-2.1-.5-.6-1.4-.6-2 0m-96.1 2.9c-.6-.6-1.6-.5-2.1.1-.6.6-.5 1.6.1 2.1.5.4 1 .8 1.4 1.2.3.2.6.3 1 .3.8 0 1.5-.7 1.5-1.5 0-.4-.2-.9-.5-1.2-.5-.2-1-.6-1.4-1m113.7-83.8c-.4-.8-1.3-1.1-2-.7-.7.3-1 1.2-.7 1.9 4.1 9.2 6.2 19.1 6.2 29.2 0 13.7-3.9 27-11.4 38.5-.5.7-.3 1.6.4 2.1s1.6.3 2.1-.4c7.8-12 11.9-25.9 11.9-40.2 0-10.5-2.2-20.9-6.5-30.4m-6.4-8.9c.7-.5.9-1.4.4-2.1-5.5-8.3-12.7-15.4-21-20.8-.7-.5-1.6-.3-2.1.4s-.3 1.6.4 2.1c8 5.2 14.9 12 20.2 20 .4.7 1.4.9 2.1.4M104.4 11c1.1.5 2.3 1 3.4 1.6.8.3 1.6 0 2-.7.3-.7 0-1.6-.6-2-1.2-.6-2.3-1.1-3.5-1.7-.8-.3-1.6.1-2 .8-.3.8 0 1.7.7 2m-55.5-.6c.8-.3 1.2-1.2.9-1.9-.3-.8-1.2-1.2-1.9-.9h-.1c-2.1.9-4.2 1.9-6.3 3-7.1 3.8-13.6 8.7-19.1 14.6-.1 0-.1.1-.2.1-3 3.2-5.7 6.7-8.1 10.4-.5.7-.3 1.6.4 2.1s1.6.3 2.1-.4v-.1l.1-.1c6.6-10.1 15.5-18.3 26.1-23.9 2.1-1.1 4.1-2 6.1-2.9"}})])
      }
    
      });
    
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/LcAvatar/LcAvatar.vue?vue&type=script&lang=js&
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var HALO_TYPE = {
  NONE: "none",
  CIVIC_LIKER: "civic-liker",
  CIVIC_LIKER_TRIAL: "civic-liker-trial"
};
var SIZE_TYPE = {
  NORMAL: "normal",
  LARGE: "large"
};
/* harmony default export */ var LcAvatarvue_type_script_lang_js_ = ({
  name: "lc-avatar",
  components: {
    CivicLikerHalo: civic_likerinline,
    CivicLikerSmallHalo: civic_liker_smallinline,
    CivicLikerTrialHalo: civic_liker_trialinline
  },
  props: {
    size: {
      type: [String, Number],
      default: SIZE_TYPE.NORMAL,
      validator: function validator(value) {
        if (!Number.isInteger(parseInt(value, 10))) {
          return SIZE_TYPE[value.toUpperCase()] === value;
        }

        return true;
      }
    },
    halo: {
      type: String,
      default: HALO_TYPE.NONE,
      validator: function validator(value) {
        return value === "" || HALO_TYPE[value.toUpperCase().replace(/-/g, "_")] === value;
      }
    },
    isFullWidth: {
      type: [Boolean, String],
      default: false
    },
    isClickable: {
      type: [Boolean, String],
      default: false
    },
    isHaloClickable: {
      type: [Boolean, String],
      default: false
    }
  },
  computed: {
    numericSize: function numericSize() {
      var size = this.size;
      var numericSize = parseInt(size, 10);

      if (Number.isInteger(numericSize) && numericSize > 0) {
        return size;
      }

      switch (size) {
        case SIZE_TYPE.LARGE:
          return 128;

        case SIZE_TYPE.NORMAL:
        default:
          return 56;
      }
    },
    rootClass: function rootClass() {
      var _ref;

      var hasHalo = this.halo && this.halo !== "none";
      var className = this.$options.name;
      var haloClassName = "".concat(className, "--with-halo");
      return [className, (_ref = {}, _defineProperty(_ref, "".concat(className, "--full-width"), !!this.isFullWidth), _defineProperty(_ref, "".concat(className, "--clickable"), !!this.isClickable), _defineProperty(_ref, "".concat(haloClassName, " ").concat(haloClassName, "--").concat(this.halo), hasHalo), _defineProperty(_ref, "".concat(haloClassName, "--clickable"), hasHalo && !!this.isHaloClickable), _ref)];
    },
    contentStyle: function contentStyle() {
      var width;

      if (this.isFullWidth) {
        width = "100%";
      } else {
        width = "".concat(this.numericSize, "px");
      }

      return {
        width: width
      };
    },
    isCivicLiker: function isCivicLiker() {
      return this.halo === HALO_TYPE.CIVIC_LIKER;
    },
    isCivicLikerTrial: function isCivicLikerTrial() {
      return this.halo === HALO_TYPE.CIVIC_LIKER_TRIAL;
    },
    isSmall: function isSmall() {
      return this.numericSize < 64;
    }
  },
  methods: {
    onClick: function onClick(e) {
      if (this.isClickable) this.$emit("click", e);
    },
    onClickHalo: function onClickHalo(e) {
      if (this.isHaloClickable) this.$emit("click-halo", e);
    }
  }
});
// CONCATENATED MODULE: ./src/components/LcAvatar/LcAvatar.vue?vue&type=script&lang=js&
 /* harmony default export */ var LcAvatar_LcAvatarvue_type_script_lang_js_ = (LcAvatarvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/LcAvatar/LcAvatar.vue?vue&type=style&index=0&lang=scss&
var LcAvatarvue_type_style_index_0_lang_scss_ = __webpack_require__("208c");

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent (
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier, /* server only */
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) { // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () { injectStyles.call(this, this.$root.$options.shadowRoot) }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functioal component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection (h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing
        ? [].concat(existing, hook)
        : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

// CONCATENATED MODULE: ./src/components/LcAvatar/LcAvatar.vue






/* normalize component */

var component = normalizeComponent(
  LcAvatar_LcAvatarvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LcAvatar = (component.exports);
// CONCATENATED MODULE: ./src/components/LcAvatar/index.js


/* harmony default export */ var components_LcAvatar = (LcAvatar);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"27a05820-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/LcChopSimple/LcChopSimple.vue?vue&type=template&id=331b5e36&
var LcChopSimplevue_type_template_id_331b5e36_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.rootClass,style:(_vm.rootStyle)},[_c('div',{staticClass:"lc-chop__content",style:(_vm.contentStyle)},[_c('chop'),_c('lc-chop-font',{attrs:{"text":_vm.text}})],1)])}
var LcChopSimplevue_type_template_id_331b5e36_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/LcChopSimple/LcChopSimple.vue?vue&type=template&id=331b5e36&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"27a05820-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/LcChopFont/LcChopFont.vue?vue&type=template&id=62df878c&
var LcChopFontvue_type_template_id_62df878c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{class:_vm.$options.name,attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":_vm.viewBox}},[_c('path',{attrs:{"d":_vm.path}})])}
var LcChopFontvue_type_template_id_62df878c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/LcChopFont/LcChopFont.vue?vue&type=template&id=62df878c&

// EXTERNAL MODULE: ./node_modules/svgpath/index.js
var svgpath = __webpack_require__("84fa");
var svgpath_default = /*#__PURE__*/__webpack_require__.n(svgpath);

// CONCATENATED MODULE: ./src/components/LcChopFont/char.js
/* harmony default export */ var LcChopFont_char = ({
  A: {
    width: 4.59,
    d: "M0,7.19,2.13,2.64a.14.14,0,0,1,.11-.07h.07a.14.14,0,0,1,.12.07L4.54,7.19a.12.12,0,0,1-.11.18H3.68c-.12,0-.18,0-.24-.17L3.2,6.66H1.36l-.24.54a.27.27,0,0,1-.25.17H.13A.12.12,0,0,1,0,7.19ZM2.79,5.74,2.28,4.63h0L1.76,5.74Z"
  },
  B: {
    width: 3.28,
    d: "M0,2.76a.13.13,0,0,1,.13-.13H1.7A1.37,1.37,0,0,1,3.16,3.89,1.35,1.35,0,0,1,2.37,5a1.28,1.28,0,0,1,.91,1.1A1.38,1.38,0,0,1,1.8,7.37H.13A.13.13,0,0,1,0,7.24ZM1.58,4.55a.47.47,0,0,0,.47-.48.45.45,0,0,0-.47-.46H1.05v.94ZM1.67,6.4a.5.5,0,0,0,.49-.49.55.55,0,0,0-.56-.48H1.05v1Z"
  },
  C: {
    width: 4.12,
    d: "M2.44,2.57a2.27,2.27,0,0,1,1.64.63.12.12,0,0,1,0,.19l-.52.54a.11.11,0,0,1-.17,0,1.39,1.39,0,0,0-.92-.34A1.34,1.34,0,0,0,1.15,5,1.34,1.34,0,0,0,2.48,6.35,1.44,1.44,0,0,0,3.39,6a.12.12,0,0,1,.17,0l.53.56a.13.13,0,0,1,0,.18,2.3,2.3,0,0,1-1.64.65,2.43,2.43,0,1,1,0-4.86Z"
  },
  D: {
    width: 4.14,
    d: "M0,2.76a.13.13,0,0,1,.12-.13H1.77a2.37,2.37,0,1,1,0,4.74H.12A.12.12,0,0,1,0,7.24ZM1.7,6.37A1.31,1.31,0,0,0,3,5,1.31,1.31,0,0,0,1.7,3.63H1.05V6.37Z"
  },
  E: {
    width: 3.06,
    d: "M0,2.76a.13.13,0,0,1,.13-.13h2.8a.14.14,0,0,1,.13.13V3.5a.13.13,0,0,1-.13.13H1.05v.84H2.6a.13.13,0,0,1,.12.13v.73a.12.12,0,0,1-.12.13H1.05v.91H2.93a.13.13,0,0,1,.13.13v.74a.13.13,0,0,1-.13.13H.13A.13.13,0,0,1,0,7.24Z"
  },
  F: {
    width: 3.06,
    d: "M0,2.76a.13.13,0,0,1,.13-.13h2.8a.14.14,0,0,1,.13.13V3.5a.13.13,0,0,1-.13.13H1.05v1H2.6a.13.13,0,0,1,.12.13v.74a.13.13,0,0,1-.12.13H1.05V7.24a.13.13,0,0,1-.12.13H.13A.13.13,0,0,1,0,7.24Z"
  },
  G: {
    width: 4.16,
    d: "M2.43,2.57a2.63,2.63,0,0,1,1.65.64.12.12,0,0,1,0,.18L3.56,4a.15.15,0,0,1-.19,0,1.21,1.21,0,0,0-.88-.33,1.36,1.36,0,0,0,0,2.71,1.66,1.66,0,0,0,.61-.1v-.4H2.67a.12.12,0,0,1-.13-.12V5.06a.13.13,0,0,1,.13-.13H4a.12.12,0,0,1,.12.13V6.88A.17.17,0,0,1,4.1,7a3.37,3.37,0,0,1-1.67.44,2.43,2.43,0,1,1,0-4.86Z"
  },
  H: {
    width: 4.06,
    d: "M0,2.76a.14.14,0,0,1,.13-.13h.8a.13.13,0,0,1,.13.13V4.47H3V2.76a.14.14,0,0,1,.13-.13h.81a.15.15,0,0,1,.13.13V7.24a.14.14,0,0,1-.13.13H3.12A.13.13,0,0,1,3,7.24V5.46H1.06V7.24a.13.13,0,0,1-.13.13H.13A.13.13,0,0,1,0,7.24Z"
  },
  I: {
    width: 1.07,
    d: "M0,2.76a.14.14,0,0,1,.13-.13H.94a.14.14,0,0,1,.13.13V7.24a.13.13,0,0,1-.13.13H.13A.13.13,0,0,1,0,7.24Z"
  },
  J: {
    width: 2.5,
    d: "M0,6.77l.45-.45a.14.14,0,0,1,.19,0A.42.42,0,0,0,1,6.46c.19,0,.4-.17.4-.51V2.76a.14.14,0,0,1,.13-.13h.82a.13.13,0,0,1,.13.13V6A1.4,1.4,0,0,1,1.05,7.43a1.31,1.31,0,0,1-1-.49A.14.14,0,0,1,0,6.77Z"
  },
  K: {
    width: 3.89,
    d: "M0,2.8a.17.17,0,0,1,.16-.17H1a.18.18,0,0,1,.17.17V4.58L2.62,2.7a.19.19,0,0,1,.12-.07H3.6a.17.17,0,0,1,.12.26l-1.58,2L3.86,7.11a.16.16,0,0,1-.13.25H2.8a.17.17,0,0,1-.12-.05L1.12,5.19v2A.17.17,0,0,1,1,7.37H.16A.16.16,0,0,1,0,7.21Z"
  },
  L: {
    width: 2.8,
    d: "M0,2.76a.13.13,0,0,1,.13-.13h.8a.14.14,0,0,1,.13.13V6.37H2.67a.13.13,0,0,1,.13.13v.74a.13.13,0,0,1-.13.13H.13A.13.13,0,0,1,0,7.24Z"
  },
  M: {
    width: 5.37,
    d: "M.77,2.68a.12.12,0,0,1,.12-.11H1a.14.14,0,0,1,.11.06L2.68,5.56h0L4.26,2.63a.14.14,0,0,1,.12-.06h.1a.14.14,0,0,1,.13.11l.76,4.54a.13.13,0,0,1-.13.15h-.8a.15.15,0,0,1-.13-.11L4,5.17H4L2.86,7.36a.15.15,0,0,1-.11.07H2.62a.14.14,0,0,1-.11-.07L1.37,5.17h0L1.06,7.26a.14.14,0,0,1-.13.11H.13A.13.13,0,0,1,0,7.22Z"
  },
  N: {
    width: 4.07,
    d: "M0,2.69a.12.12,0,0,1,.13-.12H.3L3,5.16H3V2.76a.14.14,0,0,1,.13-.13h.81a.14.14,0,0,1,.13.13V7.31a.12.12,0,0,1-.13.12H3.83l-.09,0L1.07,4.72h0V7.24a.13.13,0,0,1-.13.13H.14A.13.13,0,0,1,0,7.24Z"
  },
  O: {
    width: 4.86,
    d: "M2.43,2.57a2.43,2.43,0,1,1,0,4.86,2.43,2.43,0,1,1,0-4.86Zm0,3.78A1.35,1.35,0,1,0,1.08,5,1.35,1.35,0,0,0,2.43,6.35Z"
  },
  P: {
    width: 3.27,
    d: "M0,2.76a.13.13,0,0,1,.13-.13H1.76a1.51,1.51,0,1,1,0,3H1.05V7.24a.13.13,0,0,1-.12.13H.13A.13.13,0,0,1,0,7.24Zm1.7,1.9a.53.53,0,0,0,.53-.53.51.51,0,0,0-.53-.5H1.05v1Z"
  },
  Q: {
    width: 4.86,
    d: "M2.43,2.57A2.43,2.43,0,0,1,4.86,5,2.55,2.55,0,0,1,3.61,7.14L4.48,8.5a.13.13,0,0,1-.11.21H3.46a.14.14,0,0,1-.11-.07L2.64,7.43H2.43a2.43,2.43,0,1,1,0-4.86Zm0,3.78A1.35,1.35,0,1,0,1.08,5,1.35,1.35,0,0,0,2.43,6.35Z"
  },
  R: {
    width: 3.62,
    d: "M0,2.76a.13.13,0,0,1,.13-.13h2A1.47,1.47,0,0,1,3.62,4.1a1.46,1.46,0,0,1-1,1.35l.93,1.72a.13.13,0,0,1-.12.2H2.54a.13.13,0,0,1-.11-.06l-.9-1.79H1.06V7.24a.13.13,0,0,1-.13.13H.13A.13.13,0,0,1,0,7.24Zm2.06,1.9a.55.55,0,0,0,.52-.54.52.52,0,0,0-.52-.52h-1V4.66Z"
  },
  S: {
    width: 3.18,
    d: "M0,6.72l.32-.56a.19.19,0,0,1,.23,0,1.93,1.93,0,0,0,1,.38A.43.43,0,0,0,2,6.09c0-.28-.24-.5-.7-.68S0,4.72,0,3.91A1.4,1.4,0,0,1,1.56,2.57,2.63,2.63,0,0,1,3,3.07a.17.17,0,0,1,0,.22l-.35.52c0,.08-.17.14-.23.09a2.13,2.13,0,0,0-1-.41.4.4,0,0,0-.43.35c0,.25.2.44.74.65S3.18,5.12,3.18,6A1.48,1.48,0,0,1,1.59,7.43,2.11,2.11,0,0,1,.07,6.91C0,6.85,0,6.82,0,6.72Z"
  },
  T: {
    width: 3.26,
    d: "M1.09,3.63h-1A.13.13,0,0,1,0,3.5V2.76a.13.13,0,0,1,.13-.13h3a.14.14,0,0,1,.13.13V3.5a.13.13,0,0,1-.13.13h-1V7.24A.13.13,0,0,1,2,7.37H1.22a.14.14,0,0,1-.13-.13Z"
  },
  U: {
    width: 3.85,
    d: "M0,2.76a.14.14,0,0,1,.13-.13H1a.14.14,0,0,1,.13.13V5.5a.84.84,0,1,0,1.67,0V2.76a.14.14,0,0,1,.13-.13h.83a.14.14,0,0,1,.13.13v2.8A1.91,1.91,0,0,1,1.92,7.43,1.9,1.9,0,0,1,0,5.56Z"
  },
  V: {
    width: 4.56,
    d: "M0,2.81a.12.12,0,0,1,.12-.18H1a.14.14,0,0,1,.11.08L2.26,5.18h0L3.41,2.71a.15.15,0,0,1,.12-.08h.9a.12.12,0,0,1,.11.18L2.42,7.36a.12.12,0,0,1-.11.07H2.24a.13.13,0,0,1-.12-.07Z"
  },
  W: {
    width: 5.75,
    d: "M0,2.8a.12.12,0,0,1,.12-.17H.92a.14.14,0,0,1,.12.1L1.62,5h0L2.7,2.64a.12.12,0,0,1,.11-.07h.12c.07,0,.11,0,.12.07L4.1,5h0l.59-2.29a.13.13,0,0,1,.12-.1h.79a.12.12,0,0,1,.12.17L4.46,7.34a.13.13,0,0,1-.12.09H4.23a.12.12,0,0,1-.11-.07L2.88,4.6h0L1.63,7.36a.14.14,0,0,1-.12.07h-.1a.14.14,0,0,1-.13-.09Z"
  },
  X: {
    width: 4.14,
    d: "M1.44,4.94.08,2.82a.12.12,0,0,1,.11-.19h1a.14.14,0,0,1,.11.07L2.07,4h0L2.86,2.7A.14.14,0,0,1,3,2.63H4a.12.12,0,0,1,.11.19L2.7,4.94,4.12,7.18A.12.12,0,0,1,4,7.37H3.07A.15.15,0,0,1,3,7.31L2.07,5.94h0L1.19,7.31a.17.17,0,0,1-.11.06H.14C0,7.37,0,7.27,0,7.18Z"
  },
  Y: {
    width: 4.11,
    d: "M1.52,5.09,0,2.83a.13.13,0,0,1,.11-.2H1a.14.14,0,0,1,.11.07l.94,1.38L3,2.7s0-.07.1-.07H4a.13.13,0,0,1,.11.2L2.58,5.08V7.24a.13.13,0,0,1-.13.13H1.64a.12.12,0,0,1-.12-.13Z"
  },
  Z: {
    width: 3.33,
    d: "M0,7.12,1.8,3.64H.32A.13.13,0,0,1,.2,3.5V2.76a.14.14,0,0,1,.12-.13H3.2a.15.15,0,0,1,.13.13v.09L1.59,6.36H3.06a.13.13,0,0,1,.13.13v.74a.13.13,0,0,1-.13.13H.13A.13.13,0,0,1,0,7.24Z"
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/LcChopFont/LcChopFont.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var LcChopFontvue_type_script_lang_js_ = ({
  name: "lc-chop-font",
  props: {
    text: {
      type: String,
      default: ""
    },
    letterSpacing: {
      type: Number,
      default: 2.2
    }
  },
  data: function data() {
    return {
      path: "",
      viewBox: "0"
    };
  },
  created: function created() {
    this.setSVGProps();
  },
  watch: {
    text: function text() {
      this.setSVGProps();
    },
    letterSpacing: function letterSpacing() {
      this.setSVGProps();
    }
  },
  methods: {
    setSVGProps: function setSVGProps() {
      var _this = this;

      var width = 0;
      var path = "";
      this.text.split("").forEach(function (s, index) {
        var char = LcChopFont_char[s];
        if (!char) return;
        if (index !== 0) width += _this.letterSpacing;
        path += new svgpath_default.a(char.d).translate(width).toString();
        width += char.width;
      });
      this.viewBox = "0 0 ".concat(width.toFixed(1), " 10");
      this.path = new svgpath_default.a(path).rel().round(1).toString();
    }
  }
});
// CONCATENATED MODULE: ./src/components/LcChopFont/LcChopFont.vue?vue&type=script&lang=js&
 /* harmony default export */ var LcChopFont_LcChopFontvue_type_script_lang_js_ = (LcChopFontvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/LcChopFont/LcChopFont.vue





/* normalize component */

var LcChopFont_component = normalizeComponent(
  LcChopFont_LcChopFontvue_type_script_lang_js_,
  LcChopFontvue_type_template_id_62df878c_render,
  LcChopFontvue_type_template_id_62df878c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LcChopFont = (LcChopFont_component.exports);
// CONCATENATED MODULE: ./src/components/LcChopFont/index.js


/* harmony default export */ var components_LcChopFont = (LcChopFont);
// CONCATENATED MODULE: ./src/assets/chop/simple.svg?inline

      /* harmony default export */ var simpleinline = ({
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 365.5 109.2"}},[_c('path',{attrs:{"d":"M349.5 109.2H300c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5h49.5c6 0 11-4 11-9V14c0-5-4.9-9-11-9h-222c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5h222c8.8 0 16 6.3 16 14v81.2c0 7.8-7.1 14-16 14zm-347-81c-1.4 0-2.5-1.1-2.5-2.5V14C0 6.3 7.2 0 16 0h86.3c1.4 0 2.5 1.1 2.5 2.5S103.7 5 102.3 5H16C9.9 5 5 9 5 14v11.7c0 1.4-1.1 2.5-2.5 2.5zm229 81H16c-8.8 0-16-6.3-16-14v-55c0-1.4 1.1-2.5 2.5-2.5S5 38.8 5 40.2v55c0 5 4.9 9 11 9h215.5c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5zm43.5 0h-26.5c-1.4 0-2.5-1.1-2.5-2.5s1.1-2.5 2.5-2.5H275c1.4 0 2.5 1.1 2.5 2.5s-1.1 2.5-2.5 2.5zM121 97.7H16.1c-2.8 0-5.1-2.3-5.1-5.1V17.8c0-2.8 2.3-5.1 5.1-5.1h86.8c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5H16.1c-1.2 0-2.1.9-2.1 2.1v74.8c0 1.2.9 2.1 2.1 2.1H121c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5zm124.3 0H135c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h110.3c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5zm104.1 0H309c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h40.4c1.2 0 2.1-.9 2.1-2.1V17.8c0-1.2-.9-2.1-2.1-2.1H140c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h209.4c2.8 0 5.1 2.3 5.1 5.1v74.8c0 2.8-2.3 5.1-5.1 5.1zM125 15.7h-8c-.8 0-1.5-.7-1.5-1.5s.7-1.5 1.5-1.5h8c.8 0 1.5.7 1.5 1.5s-.7 1.5-1.5 1.5z"}})])
      }
    
      });
    
// CONCATENATED MODULE: ./src/utils/index.js
function wiggleValue(value, deviation) {
  var vInt = parseFloat(value, 10);
  var dInt = parseFloat(deviation, 10);
  return vInt - dInt + Math.random() * dInt * 2;
}
// CONCATENATED MODULE: ./src/mixins/lc-chop.js
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { lc_chop_defineProperty(target, key, source[key]); }); } return target; }

function lc_chop_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var EXTRA_PROPS = {
  date: {
    type: Date,
    default: undefined
  },
  text: {
    type: String,
    default: undefined
  },
  isBeta: {
    type: [Boolean, String],
    default: false
  },
  isTrial: {
    type: [Boolean, String],
    default: false
  },
  isTrialling: {
    type: [Boolean, String],
    default: false
  }
};
/* harmony default export */ var lc_chop = (function (_ref) {
  var className = _ref.className,
      _ref$defaultSize = _ref.defaultSize,
      defaultSize = _ref$defaultSize === void 0 ? 0 : _ref$defaultSize,
      _ref$contentWiggleRot = _ref.contentWiggleRotateZ,
      contentWiggleRotateZ = _ref$contentWiggleRot === void 0 ? 0 : _ref$contentWiggleRot,
      _ref$valueWiggleRotat = _ref.valueWiggleRotateZ,
      valueWiggleRotateZ = _ref$valueWiggleRotat === void 0 ? 0 : _ref$valueWiggleRotat,
      _ref$props = _ref.props,
      extraProps = _ref$props === void 0 ? [] : _ref$props;
  var props = {};
  var computed = {};
  extraProps.forEach(function (key) {
    if (EXTRA_PROPS[key]) {
      props[key] = EXTRA_PROPS[key];

      switch (key) {
        case "date":
          computed.dateValue = function () {
            var date = this.date;

            if (date) {
              var d = date.getDate();
              var m = date.getMonth() + 1;
              var y = date.getFullYear();
              return "".concat(d < 10 ? "0" : "").concat(d, ".").concat(m < 10 ? "0" : "").concat(m, ".").concat(y);
            }

            return null;
          };

          break;

        default:
          break;
      }
    }
  });
  return {
    props: _objectSpread({}, props, {
      size: {
        type: [Number, String],
        default: defaultSize,
        validator: function validator(value) {
          var v = parseFloat(value, 10);
          return !Number.isNaN(v) && v >= 0;
        }
      },
      rotateZ: {
        type: [Number, String],
        default: 0,
        validator: function validator(value) {
          var v = parseFloat(value, 10);
          return !Number.isNaN(v);
        }
      }
    }),
    computed: _objectSpread({}, computed, {
      mixinClass: function mixinClass() {
        var _ref2;

        return ["lc-chop", className, (_ref2 = {}, lc_chop_defineProperty(_ref2, "".concat(className, "--beta"), !!this.isBeta), lc_chop_defineProperty(_ref2, "".concat(className, "--trial"), !!this.isTrial), lc_chop_defineProperty(_ref2, "".concat(className, "--trialling"), !!this.isTrialling), _ref2)];
      },
      rootClass: function rootClass() {
        return this.mixinClass;
      },
      rootStyle: function rootStyle() {
        return {
          fontSize: "".concat(this.size, "px")
        };
      },
      contentStyle: function contentStyle() {
        var value = wiggleValue(this.rotateZ, contentWiggleRotateZ);
        return {
          transform: "rotateZ(".concat(value, "deg)")
        };
      },
      valueStyle: function valueStyle() {
        var value = wiggleValue(0, valueWiggleRotateZ);
        return {
          transform: "rotateZ(".concat(value, "deg)")
        };
      }
    })
  };
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/LcChopSimple/LcChopSimple.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LcChopSimplevue_type_script_lang_js_ = ({
  name: "lc-chop-simple",
  components: {
    LcChopFont: components_LcChopFont,
    Chop: simpleinline
  },
  props: {
    text: {
      type: String,
      default: ""
    }
  },
  mixins: [lc_chop({
    className: "lc-chop-simple",
    defaultSize: 244,
    contentWiggleRotateZ: 8,
    props: ["isTrial"]
  })]
});
// CONCATENATED MODULE: ./src/components/LcChopSimple/LcChopSimple.vue?vue&type=script&lang=js&
 /* harmony default export */ var LcChopSimple_LcChopSimplevue_type_script_lang_js_ = (LcChopSimplevue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/LcChopSimple/LcChopSimple.vue?vue&type=style&index=0&lang=scss&
var LcChopSimplevue_type_style_index_0_lang_scss_ = __webpack_require__("2c60");

// CONCATENATED MODULE: ./src/components/LcChopSimple/LcChopSimple.vue






/* normalize component */

var LcChopSimple_component = normalizeComponent(
  LcChopSimple_LcChopSimplevue_type_script_lang_js_,
  LcChopSimplevue_type_template_id_331b5e36_render,
  LcChopSimplevue_type_template_id_331b5e36_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LcChopSimple = (LcChopSimple_component.exports);
// CONCATENATED MODULE: ./src/components/LcChopSimple/index.js


/* harmony default export */ var components_LcChopSimple = (LcChopSimple);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"27a05820-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/LcChopCountdown/LcChopCountdown.vue?vue&type=template&id=5f8ade5c&
var LcChopCountdownvue_type_template_id_5f8ade5c_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"lc-chop lc-chop-countdown",style:(_vm.rootStyle)},[_c('div',{staticClass:"lc-chop__content",style:(_vm.contentStyle)},[_c('chop'),_c('span',{staticClass:"lc-chop__content__value"},[_c('span',[_vm._v(_vm._s(_vm.digit1))]),_c('span',[_vm._v(_vm._s(_vm.digit0))])])],1)])}
var LcChopCountdownvue_type_template_id_5f8ade5c_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/LcChopCountdown/LcChopCountdown.vue?vue&type=template&id=5f8ade5c&

// CONCATENATED MODULE: ./src/assets/chop/countdown.svg?inline

      /* harmony default export */ var countdowninline = ({
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 156.39 206.45","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M16 73.88a1 1 0 0 0-2 0v6a1 1 0 0 0 2 0zm0 14a1 1 0 0 0-2 0v2a1 1 0 0 0 2 0zm-1 41a1 1 0 0 0-1 1v2.5a1 1 0 0 0 2 0v-2.5a1 1 0 0 0-1-1zM21.05 19.1A20.44 20.44 0 0 0 17 23.89a1 1 0 0 0 .33 1.37 1 1 0 0 0 1.37-.33 19 19 0 0 1 3.67-4.33 1 1 0 1 0-1.32-1.5zm83.49-3.04a1 1 0 1 0 0-2h-6a1 1 0 0 0 0 2zm-14 0a1 1 0 1 0 0-2h-6a1 1 0 0 0 0 2zM34.53 190.39a19.31 19.31 0 0 1-2.53-.17 1 1 0 1 0-.27 2 20.06 20.06 0 0 0 2.8.19h1.22a1 1 0 0 0 0-2zM15 170.88a1 1 0 0 0-1 1 20.39 20.39 0 0 0 1 6.21 1 1 0 0 0 1 .69.81.81 0 0 0 .31-.05 1 1 0 0 0 .65-1.25 18.3 18.3 0 0 1-.87-5.6 1 1 0 0 0-1.09-1zm1-111a1 1 0 0 0-2 0v6a1 1 0 0 0 2 0zM20.56 184a1 1 0 1 0-1.5 1.32 20.22 20.22 0 0 0 4.8 4 1 1 0 0 0 1.37-.33 1 1 0 0 0-.33-1.38 18.51 18.51 0 0 1-4.34-3.61zm39.29 6.39a1 1 0 1 0 0 2h6a1 1 0 1 0 0-2zM16 45.88a1 1 0 0 0-2 0v6a1 1 0 0 0 2 0zm0-11.28a19.93 19.93 0 0 1 .16-2.6 1 1 0 1 0-2-.28A20.88 20.88 0 0 0 14 34.6v3.28a1 1 0 0 0 2 0zm63.85 155.79h-6a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2zm61.55-70.81a1 1 0 0 0-1 1v6a1 1 0 1 0 2 0v-6a1 1 0 0 0-1-1zm-39.55 70.81a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2zm14 0a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2zM62.54 14.06h-6a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2zm64.25 176.73a1 1 0 0 0 .95.7 1 1 0 0 0 .3-.05 20.14 20.14 0 0 0 5.63-2.79 1 1 0 1 0-1.15-1.63 18.66 18.66 0 0 1-5.08 2.51 1 1 0 0 0-.65 1.26zM142.4 78.58a1 1 0 0 0-2 0v6a1 1 0 1 0 2 0zm-3.76-55.83A1 1 0 0 0 137 23.9a18.58 18.58 0 0 1 2.53 5.1 1 1 0 0 0 .95.69.84.84 0 0 0 .31-.05 1 1 0 0 0 .65-1.25 20.39 20.39 0 0 0-2.8-5.64zm3.76 41.83a1 1 0 0 0-2 0v6a1 1 0 1 0 2 0zM87.85 192.39h6a1 1 0 1 0 0-2h-6a1 1 0 0 0 0 2zM76.54 16.06a1 1 0 1 0 0-2h-6a1 1 0 0 0 0 2zm54.95 2.7a1.13 1.13 0 0 0 .52.14 1 1 0 0 0 .86-.48 1 1 0 0 0-.33-1.37 20.53 20.53 0 0 0-5.81-2.41 1 1 0 0 0-1.21.73 1 1 0 0 0 .74 1.21 18.06 18.06 0 0 1 5.23 2.18zm-12.95-2.7a1 1 0 1 0 0-2h-1a1 1 0 0 0 0 2zm-70-2h-6a1 1 0 0 0 0 2h6a1 1 0 1 0 0-2zm93.86 22.52a1 1 0 0 0-2 0v6a1 1 0 1 0 2 0zM34.53 14.06a20.52 20.52 0 0 0-6.19.95 1 1 0 0 0 .3 2 1 1 0 0 0 .3 0 18.51 18.51 0 0 1 5.6-.86 1 1 0 1 0 0-2zm107.87 92.52a1 1 0 0 0-2 0v6a1 1 0 1 0 2 0zm0-56a1 1 0 0 0-2 0v6a1 1 0 1 0 2 0zM138.53 183a1 1 0 0 0 .85-.48 20.46 20.46 0 0 0 2.43-5.79 1 1 0 0 0-1.95-.48 18.34 18.34 0 0 1-2.18 5.23 1 1 0 0 0 .33 1.37 1 1 0 0 0 .52.15z"}}),_c('path',{attrs:{"d":"M4.77 88.89a2.5 2.5 0 0 0 5 0V33.81A23.3 23.3 0 0 1 33 10.54h71.81a2.5 2.5 0 1 0 0-5H33A28.3 28.3 0 0 0 4.77 33.81zm2.5 7.54a2.5 2.5 0 0 0-2.5 2.5v17a2.5 2.5 0 0 0 5 0v-17a2.5 2.5 0 0 0-2.5-2.5zm28.98 99.48H33a23.3 23.3 0 0 1-23.23-23.28v-2.85h83.16a1 1 0 1 0 0-2H9.77v-28h8.09a1 1 0 0 0 0-2H9.77v-11.26a2.5 2.5 0 0 0-5 0v46.11A28.31 28.31 0 0 0 33 200.91h3.21a2.5 2.5 0 0 0 0-5zm115.37-23.28v-10.79a2.5 2.5 0 0 0-5 0v5.94H130.5a1 1 0 0 0 0 2h16.12v2.85a23.3 23.3 0 0 1-23.27 23.28h-74a2.5 2.5 0 1 0 0 5h74a28.31 28.31 0 0 0 28.27-28.28zm2.77-11h2v2.01h-2zM93 0h2.01v2H93zm18.05 0h2.01v2h-2.01zm25.08 202.75l.68 1.88c.65-.24 1.3-.5 1.92-.78l-.82-1.83c-.58.26-1.18.51-1.78.73zm-5.63 1.41l.29 2c.68-.09 1.37-.22 2-.36l-.42-2c-.59.2-1.23.27-1.87.36zm23.5-22.67l2 .35c.12-.68.21-1.37.29-2.05l-2-.22c-.13.64-.22 1.29-.29 1.92zm.39-7.82h2v2.01h-2zm0-6.02h2v2.01h-2zm-4.77 24.53l1.65 1.12c.39-.57.76-1.16 1.11-1.76l-1.73-1c-.33.56-.65 1.11-1.03 1.64zm-3.73 4.44l1.39 1.44c.49-.48 1-1 1.44-1.49l-1.49-1.34c-.43.48-.88.94-1.34 1.39zm6.46-9.56l1.85.75c.27-.64.51-1.3.72-1.95l-1.9-.62c-.2.61-.43 1.22-.67 1.82zm-11.03 13.14l1.07 1.69c.58-.37 1.16-.76 1.71-1.16l-1.17-1.62c-.52.38-1.06.75-1.61 1.09zM56.89 0h2.01v2h-2.01zM44.85 0h2.01v2h-2.01zm6.02 0h2.01v2h-2.01zM32.81 0h2.01v2h-2.01zm54.17 0h2.01v2h-2.01zM38.83 0h2.01v2h-2.01zM62.9 0h2.01v2H62.9zm18.06 0h2.01v2h-2.01zm-6.02 0h2.01v2h-2.01zM28.83 2l-.07-2c-.68 0-1.38.07-2.07.15l.21 2c.64-.06 1.29-.15 1.93-.15zm40.09-2h2.01v2h-2.01zm87.46 29.2h-2v1.99h2v-1.33c.01-.22 0-.44 0-.66zM117.07 0h2.01v2h-2.01zm37.32 59.31h2v2.01h-2zM123.09 0h2.01v2h-2.01zm31.3 35.24h2v2.01h-2zm0 6.02h2v2.01h-2zM131.25.37c-.68-.11-1.37-.19-2.06-.25l-.17 2q1 .09 1.92.24zm20.29 13.18c-.38-.58-.78-1.15-1.19-1.7l-1.6 1.21c.39.51.76 1 1.12 1.58zM156 25.07c-.11-.68-.24-1.37-.4-2l-1.94.46c.14.62.27 1.26.37 1.9zm-8.38-16.34c-.49-.49-1-1-1.51-1.42l-1.32 1.51c.49.42 1 .87 1.42 1.32zm-4.83-3.91c-.57-.38-1.17-.74-1.77-1.08l-1 1.75c.57.32 1.13.65 1.66 1zM137.26 2c-.65-.25-1.31-.48-2-.68l-.58 1.91c.61.19 1.23.4 1.83.63zm17.13 87.41h2v2.01h-2zm0 30.09h2v2.01h-2zm0-12.04h2v2.01h-2zm0 18.06h2v2.01h-2zm0-12.04h2v2.01h-2zm0 24.08h2v2.01h-2zm-90.05 66.89h2.01v2h-2.01zm90.05-60.87h2v2.01h-2zm0-60.19h2v2.01h-2zm0-12.04h2v2.01h-2zm0-6.02h2v2.01h-2zm0 30.1h2v2.01h-2zm0 6.01h2v2.01h-2zm0 30.1h2v2.01h-2zM0 172.15h2v2.01H0zm0-6.02h2v2.01H0zM23.09 2.83L22.61.89c-.67.16-1.34.36-2 .57l.62 1.9c.61-.2 1.24-.36 1.86-.53zM0 160.11h2v2.01H0zm2 18.01l-2 .1c0 .69.1 1.38.19 2.07l2-.25c-.06-.63-.11-1.28-.19-1.92zm1 5.72l-2 .52c.18.66.38 1.33.61 2l1.89-.65c-.19-.63-.38-1.25-.5-1.87zm-3-47.8h2v2.01H0zm0-6.02h2v2.01H0zm0-18.06h2v2.01H0zm0 42.13h2v2.01H0zm0-48.15h2v2.01H0zm3.26 84.22c.31.61.65 1.22 1 1.81l1.72-1c-.34-.55-.65-1.12-.94-1.69zM0 142.06h2v2.01H0zm58.32 62.39h2.01v2h-2.01zm24.07 0h2.01v2h-2.01zm-6.02 0h2.01v2h-2.01zM0 87.89h2v2.01H0zm88.41 116.56h2.01v2h-2.01zm-18.05 0h2.01v2h-2.01zm-30.1 0h2.01v2h-2.01zm54.17 0h2.01v2h-2.01zM11 199.76c.53.44 1.09.86 1.66 1.26l1.15-1.64c-.53-.37-1.05-.76-1.55-1.17zm5.24 3.4c.61.32 1.24.62 1.87.89l.79-1.84c-.59-.25-1.18-.53-1.75-.83zm-9.6-7.79c.43.53.89 1.06 1.36 1.56l1.47-1.36c-.44-.47-.87-1-1.27-1.46zm21.64 9.03l-.11 2h2.06v-2h-.37c-.53.05-1.06.03-1.58 0zm24.02.05h2.01v2H52.3zm-30.3.96c.66.18 1.34.34 2 .47l.38-2c-.63-.12-1.26-.27-1.88-.44zM0 45.76h2v2.01H0zm0-12.04h2v2.01H0zm118.5 170.73h2.01v2h-2.01zM0 39.74h2v2.01H0zM0 57.8h2v2.01H0zm124.52 146.65h2.13v2h-2.13zM0 51.78h2v2.01H0zm2.08-24l-2-.15C0 28.31 0 29 0 29.7h2c0-.63 0-1.28.08-1.92zm10.65-19.9L11.5 6.31c-.54.42-1.07.87-1.59 1.33l1.34 1.49c.48-.43.98-.85 1.48-1.25zm87.72 196.57h2.01v2h-2.01zM17.65 4.81L16.77 3c-.62.31-1.24.64-1.83 1l1 1.73c.55-.33 1.13-.64 1.71-.92zm94.84 199.64h2.01v2h-2.01zM5.29 16.7l-1.76-.94c-.32.6-.63 1.23-.92 1.86l1.83.82c.26-.59.56-1.17.85-1.74zm3.27-4.79L7 10.62c-.45.52-.88 1.07-1.29 1.63l1.62 1.18c.41-.52.81-1.03 1.23-1.52zM0 69.83h2v2.01H0zm0 6.02h2v2.01H0zm0 6.02h2v2.01H0zm106.47 122.58h2.01v2h-2.01zM0 63.81h2v2.01H0z"}}),_c('path',{attrs:{"d":"M144.22 138.78a1 1 0 0 1-1 1H25.85a1 1 0 1 1 0-2H140.4v-3.2a1 1 0 0 1 2 0v3.2h.82a1 1 0 0 1 1 1zm2.4 8.78a2.5 2.5 0 0 0 5 0V33.81a28.3 28.3 0 0 0-28.27-28.27h-4.5a2.5 2.5 0 0 0 0 5h4.5a23.3 23.3 0 0 1 23.27 23.27zM35.21 30.1a4.23 4.23 0 0 1 1.85.68.32.32 0 0 0 .48-.14l.35-.52a.33.33 0 0 0-.09-.46 4.55 4.55 0 0 0-2.53-.81 2.68 2.68 0 0 0-3 2.53c0 1.59 1.09 2.32 2.49 2.91s2.07 1.08 2.07 1.9a1.38 1.38 0 0 1-1.55 1.28 4 4 0 0 1-2.19-.95.32.32 0 0 0-.47.11c-.12.18-.23.39-.35.56s0 .33.08.44a4.4 4.4 0 0 0 2.95 1.09 2.8 2.8 0 0 0 3.05-2.59c0-1.68-1.35-2.43-2.94-3.07-1.14-.47-1.74-1-1.74-1.73 0-.51.39-1.23 1.54-1.23zm10.72 8.48h.9a.27.27 0 0 0 .26-.26v-8h2.24a.26.26 0 0 0 .26-.26v-.76a.26.26 0 0 0-.26-.26h-5.9a.26.26 0 0 0-.26.26v.7a.26.26 0 0 0 .26.26h2.24v8.05a.27.27 0 0 0 .26.27zm7.67 0h.86a.35.35 0 0 0 .32-.21c.27-.63.56-1.24.83-1.87h4.48l.85 1.87a.32.32 0 0 0 .32.21h.86a.24.24 0 0 0 .23-.36L58.17 29a.32.32 0 0 0-.23-.15h-.14a.34.34 0 0 0-.23.15l-4.21 9.22a.25.25 0 0 0 .24.36zm4.22-7h.07l1.68 3.76h-3.42zm10.01-2.33v9.07a.26.26 0 0 0 .26.26H69a.27.27 0 0 0 .26-.26v-3.5h2.07l1.82 3.63a.25.25 0 0 0 .22.13h1.07a.26.26 0 0 0 .23-.4l-1.89-3.48a3 3 0 0 0 2-2.78 3 3 0 0 0-3-2.93h-3.69a.26.26 0 0 0-.26.26zm1.44 1.07h2.44A1.68 1.68 0 0 1 73.38 32a1.71 1.71 0 0 1-1.67 1.7h-2.44zm10.6-1.07V30a.26.26 0 0 0 .26.26h2.24v8.05a.27.27 0 0 0 .26.26h.9a.27.27 0 0 0 .26-.26v-8H86a.25.25 0 0 0 .26-.26v-.76A.25.25 0 0 0 86 29h-5.87a.26.26 0 0 0-.26.25z"}}),_c('rect',{attrs:{"x":"91.87","y":"28.99","width":"1.43","height":"9.59","rx":".26"}}),_c('path',{attrs:{"d":"M106.63 29.25v6.48l-5.94-6.88h-.35a.26.26 0 0 0-.26.25v9.22a.28.28 0 0 0 .26.26h.87a.26.26 0 0 0 .26-.26v-6.68l6 7.08h.35a.27.27 0 0 0 .27-.25v-9.22a.27.27 0 0 0-.27-.26h-.87a.26.26 0 0 0-.32.26zM119 38.72a6.8 6.8 0 0 0 3.39-.91.31.31 0 0 0 .11-.22v-3.31a.26.26 0 0 0-.25-.26h-2.49a.25.25 0 0 0-.26.26v.79a.25.25 0 0 0 .26.25h1.34v1.53a4.73 4.73 0 0 1-2.05.47 3.56 3.56 0 0 1 0-7.11 3.68 3.68 0 0 1 2.33.93c.13.12.24.13.35 0l.62-.64a.27.27 0 0 0 0-.39 4.95 4.95 0 0 0-8.26 3.68 4.91 4.91 0 0 0 4.91 4.93zM54.92 52.47a4 4 0 0 1-2.19-.95.32.32 0 0 0-.47.11c-.12.18-.23.39-.35.56s0 .33.08.44a4.39 4.39 0 0 0 2.94 1.09A2.8 2.8 0 0 0 58 51.13c0-1.68-1.36-2.43-3-3.07-1.13-.47-1.74-1-1.74-1.73 0-.51.4-1.23 1.55-1.23a4.23 4.23 0 0 1 1.85.68.33.33 0 0 0 .48-.14l.34-.52a.32.32 0 0 0-.08-.46 4.59 4.59 0 0 0-2.53-.81 2.68 2.68 0 0 0-3 2.53c0 1.59 1.09 2.32 2.49 2.91s2.07 1.08 2.07 1.9a1.38 1.38 0 0 1-1.51 1.28zm8.37-3.67a4.93 4.93 0 1 0 4.92-4.95 4.89 4.89 0 0 0-4.92 4.95zm4.92-3.58a3.59 3.59 0 0 1 3.56 3.58 3.56 3.56 0 0 1-7.11 0 3.59 3.59 0 0 1 3.55-3.58zm15.22 8.5a4.94 4.94 0 1 0-4.92-4.92 4.9 4.9 0 0 0 4.92 4.92zm0-8.5A3.59 3.59 0 0 1 87 48.8a3.56 3.56 0 0 1-7.11 0 3.59 3.59 0 0 1 3.54-3.58zm11.26-1.37a.26.26 0 0 0-.26.25v9.22a.27.27 0 0 0 .26.26h.86a.26.26 0 0 0 .26-.26v-6.68l6 7.08h.36a.26.26 0 0 0 .26-.25v-9.22a.27.27 0 0 0-.26-.26h-.88a.26.26 0 0 0-.26.26v6.48l-6-6.88zm30.83 124.93a1 1 0 0 0-1-1h-23.67a1 1 0 0 0 0 2h23.67a1 1 0 0 0 1-1zM21 149a.3.3 0 0 0-.28.29v10.27a.3.3 0 0 0 .28.29h3.78a5.43 5.43 0 1 0 0-10.85zm6.65 5.41a3 3 0 0 1-3 3.15h-1.56v-6.28h1.49a3 3 0 0 1 3.02 3.12zm11.28-5.58h-.15a.32.32 0 0 0-.27.18l-4.85 10.43a.27.27 0 0 0 .26.4h1.71a.58.58 0 0 0 .56-.37l.56-1.24H41l.56 1.22c.14.3.26.39.54.39h1.72a.27.27 0 0 0 .27-.4L39.19 149a.3.3 0 0 0-.26-.17zm-1.25 7.29l1.16-2.56 1.16 2.56zm12.21 3.72h1.84a.31.31 0 0 0 .3-.29v-5l3.47-5.16a.29.29 0 0 0-.25-.45h-2a.3.3 0 0 0-.25.14l-2.16 3.18-2.15-3.18a.31.31 0 0 0-.25-.14h-2a.29.29 0 0 0-.25.45l3.42 5.18v4.93a.3.3 0 0 0 .28.34zm12.79-2a4.6 4.6 0 0 1-2.2-.85.4.4 0 0 0-.53.09l-.73 1.29c-.12.22-.08.28.08.43a4.88 4.88 0 0 0 3.49 1.2 3.41 3.41 0 0 0 3.65-3.21c0-2.11-1.92-3.06-3.13-3.54s-1.69-.93-1.69-1.5a.9.9 0 0 1 1-.79 4.88 4.88 0 0 1 2.22.93c.14.11.41 0 .52-.2l.79-1.2A.37.37 0 0 0 66 150a5.74 5.74 0 0 0-3.32-1.17c-2.38 0-3.58 1.56-3.58 3.09 0 1.86 1.68 2.9 3 3.43 1.05.41 1.6.91 1.6 1.56a1 1 0 0 1-1.02.93zm16.97 2h1.86a.3.3 0 0 0 .29-.29v-8.28H84a.3.3 0 0 0 .3-.3v-1.69a.3.3 0 0 0-.3-.28h-6.86a.3.3 0 0 0-.3.29V151a.3.3 0 0 0 .3.3h2.21v8.28a.31.31 0 0 0 .3.26zm19.61-5.41a5.58 5.58 0 1 0-5.58 5.57 5.57 5.57 0 0 0 5.58-5.57zm-5.58 3.09a3.11 3.11 0 1 1 3.1-3.09 3.11 3.11 0 0 1-3.1 3.09zm22.01-6.22a2.86 2.86 0 0 1 2 .74.32.32 0 0 0 .42 0l1.22-1.3a.28.28 0 0 0 0-.42 6 6 0 0 0-3.78-1.46 5.57 5.57 0 1 0 0 11.13 7.78 7.78 0 0 0 3.84-1 .38.38 0 0 0 .13-.24v-4.17a.29.29 0 0 0-.28-.3h-3.11a.28.28 0 0 0-.3.3v1.53a.28.28 0 0 0 .3.28h1v.9a3.77 3.77 0 0 1-1.38.25 3.11 3.11 0 0 1 0-6.22zm19.4 3.13a5.57 5.57 0 1 0-5.58 5.57 5.57 5.57 0 0 0 5.58-5.57zm-8.66 0a3.09 3.09 0 1 1 3.08 3.09 3.12 3.12 0 0 1-3.08-3.09zM82 179.58a1 1 0 0 0-1.26-.64l-1.58.51v-1.66a1 1 0 0 0-2 0v1.66l-1.58-.51a1 1 0 0 0-1.26.64 1 1 0 0 0 .65 1.26l1.57.51-1 1.35a1 1 0 0 0 1.62 1.17l1-1.34 1 1.34a1 1 0 0 0 .81.41 1 1 0 0 0 .81-1.58l-1-1.35 1.58-.51a1 1 0 0 0 .64-1.26zm5.16 4.51a1 1 0 0 0 .59.19 1 1 0 0 0 .81-.41l1-1.34 1 1.34a1 1 0 0 0 .81.41 1 1 0 0 0 .81-1.58l-1-1.35 1.58-.51a1 1 0 1 0-.62-1.9l-1.58.51v-1.66a1 1 0 0 0-2 0v1.66l-1.56-.51a1 1 0 1 0-.61 1.9l1.57.51-1 1.35a1 1 0 0 0 .2 1.39zm-16.47-4.51a1 1 0 0 0-1.26-.64l-1.58.51v-1.66a1 1 0 0 0-2 0v1.66l-1.57-.51a1 1 0 0 0-1.26.64 1 1 0 0 0 .64 1.26l1.58.51-1 1.35a1 1 0 0 0 1.62 1.17l1-1.34 1 1.34a1 1 0 0 0 .81.41 1 1 0 0 0 .81-1.58l-1-1.35 1.58-.51a1 1 0 0 0 .63-1.26z"}})])
      }
    
      });
    
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/LcChopCountdown/LcChopCountdown.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var LcChopCountdownvue_type_script_lang_js_ = ({
  name: "lc-chop-countdown",
  components: {
    Chop: countdowninline
  },
  props: {
    days: {
      type: [Number, String],
      default: 0,
      validator: function validator(value) {
        var v = parseInt(value, 10);
        return Number.isInteger(v);
      }
    },
    date: {
      type: Date,
      default: undefined
    }
  },
  mixins: [lc_chop({
    defaultSize: 104,
    contentWiggleRotateZ: 5
  })],
  computed: {
    value: function value() {
      var value;

      if (this.date) {
        var now = new Date().getTime();
        var endDate = this.date.getTime();
        value = Math.ceil((endDate - now) / 86400000);
      } else {
        value = parseInt(this.days, 10);
      } // Limit the value within 0 - 99


      return Math.max(0, Math.min(99, value));
    },
    digit0: function digit0() {
      return this.value % 10;
    },
    digit1: function digit1() {
      return Math.floor(this.value / 10);
    }
  }
});
// CONCATENATED MODULE: ./src/components/LcChopCountdown/LcChopCountdown.vue?vue&type=script&lang=js&
 /* harmony default export */ var LcChopCountdown_LcChopCountdownvue_type_script_lang_js_ = (LcChopCountdownvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/LcChopCountdown/LcChopCountdown.vue?vue&type=style&index=0&lang=scss&
var LcChopCountdownvue_type_style_index_0_lang_scss_ = __webpack_require__("608e");

// CONCATENATED MODULE: ./src/components/LcChopCountdown/LcChopCountdown.vue






/* normalize component */

var LcChopCountdown_component = normalizeComponent(
  LcChopCountdown_LcChopCountdownvue_type_script_lang_js_,
  LcChopCountdownvue_type_template_id_5f8ade5c_render,
  LcChopCountdownvue_type_template_id_5f8ade5c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LcChopCountdown = (LcChopCountdown_component.exports);
// CONCATENATED MODULE: ./src/components/LcChopCountdown/index.js


/* harmony default export */ var components_LcChopCountdown = (LcChopCountdown);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"27a05820-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/LcChopCivicLiker/LcChopCivicLiker.vue?vue&type=template&id=03071260&
var LcChopCivicLikervue_type_template_id_03071260_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.rootClass,style:(_vm.rootStyle)},[_c('div',{staticClass:"lc-chop__content",style:(_vm.contentStyle)},[_c('chop'),_c('span',{staticClass:"lc-chop__content__value",style:(_vm.valueStyle)},[_vm._v("\n      "+_vm._s(_vm.value)+"\n    ")])],1)])}
var LcChopCivicLikervue_type_template_id_03071260_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/LcChopCivicLiker/LcChopCivicLiker.vue?vue&type=template&id=03071260&

// CONCATENATED MODULE: ./src/assets/chop/civic-liker.svg?inline

      /* harmony default export */ var chop_civic_likerinline = ({
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 192.5 192.5"}},[_c('defs'),_c('path',{staticClass:"a",attrs:{"d":"M148.1 171.35a91.3 91.3 0 0 1-105.16-1 2.5 2.5 0 1 0-2.94 4.02 96.29 96.29 0 0 0 111 1.09 2.5 2.5 0 0 0-2.85-4.11zM177.07 44a2.5 2.5 0 1 0-4.19 2.72 91.29 91.29 0 0 1-16.79 118.46 2.5 2.5 0 0 0 3.28 3.78 96.29 96.29 0 0 0 17.7-125zM51.91 16.48a91.3 91.3 0 0 1 115 22 2.5 2.5 0 1 0 3.86-3.17 96.29 96.29 0 0 0-121.29-23.2 2.5 2.5 0 1 0 2.43 4.37zM5 96.25a91.66 91.66 0 0 1 37.06-73.42 2.5 2.5 0 0 0-3-4 96.3 96.3 0 0 0-28.38 121.52 2.49 2.49 0 0 0 2.22 1.36 2.43 2.43 0 0 0 1.14-.28 2.51 2.51 0 0 0 1.08-3.37A90.17 90.17 0 0 1 5 96.25zm15.54 50.96A2.5 2.5 0 1 0 16.4 150a96.53 96.53 0 0 0 14.53 16.93 2.5 2.5 0 0 0 3.39-3.67 91.81 91.81 0 0 1-13.78-16.05z"}}),_c('path',{staticClass:"a",attrs:{"d":"M96.62 7.71h-.37c-1.23 0-2.48 0-3.7.08a1.5 1.5 0 0 0 .06 3h.06c1.18 0 2.39-.08 3.58-.08h.36a1.5 1.5 0 0 0 0-3zM74.61 182.13c1.31.33 2.65.64 4 .9a1.53 1.53 0 0 0 .3 0 1.5 1.5 0 0 0 .29-3c-1.28-.26-2.57-.55-3.84-.87a1.5 1.5 0 1 0-.73 2.91zM132.8 18.88c1.18.56 2.37 1.16 3.52 1.77a1.52 1.52 0 0 0 .7.18 1.5 1.5 0 0 0 .71-2.83c-1.2-.63-2.42-1.25-3.65-1.83a1.5 1.5 0 1 0-1.28 2.71zm-54.09-6.41a1.53 1.53 0 0 0 .3 0c1.28-.26 2.58-.5 3.87-.7a1.5 1.5 0 1 0-.46-3c-1.34.21-2.69.45-4 .72a1.5 1.5 0 0 0 .3 3zm32.1-3.57c-1.33-.22-2.69-.42-4-.58a1.51 1.51 0 0 0-1.67 1.32 1.5 1.5 0 0 0 1.32 1.66c1.29.16 2.6.34 3.89.56h.25a1.5 1.5 0 0 0 .24-3zM129.94 178a1.47 1.47 0 0 0 .58-.12c1.25-.52 2.5-1.08 3.71-1.66a1.5 1.5 0 0 0-1.28-2.71c-1.18.56-2.39 1.1-3.59 1.6a1.5 1.5 0 0 0 .58 2.89zm-41.28 6.48c1.34.11 2.71.19 4.07.25h.06a1.5 1.5 0 0 0 .06-3c-1.32 0-2.64-.13-3.93-.24a1.5 1.5 0 0 0-.26 3zm35.98-172.13a87.5 87.5 0 0 0-3.89-1.21 1.5 1.5 0 1 0-.83 2.88c1.26.36 2.52.76 3.76 1.17a1.34 1.34 0 0 0 .48.08 1.5 1.5 0 0 0 .48-2.92zm-8.01 170.05a1.34 1.34 0 0 0 .35-.05c1.32-.31 2.64-.66 3.94-1a1.5 1.5 0 1 0-.83-2.88c-1.26.36-2.54.7-3.81 1a1.5 1.5 0 0 0 .35 3zm-13.84 2.15h.12c1.34-.1 2.71-.23 4-.4a1.5 1.5 0 1 0-.36-3c-1.3.15-2.61.28-3.91.38a1.5 1.5 0 0 0 .1 3zM176.94 129a1.47 1.47 0 0 0 .54.1 1.5 1.5 0 0 0 1.4-1c.49-1.26 1-2.55 1.38-3.84a1.5 1.5 0 1 0-2.84-1c-.42 1.25-.87 2.49-1.34 3.71a1.5 1.5 0 0 0 .86 2.03zm3.27-61a1.5 1.5 0 0 0-2.85.95c.42 1.24.81 2.5 1.17 3.76a1.5 1.5 0 0 0 1.47 1.13 1.45 1.45 0 0 0 .41-.06 1.49 1.49 0 0 0 1-1.85c-.41-1.3-.77-2.61-1.2-3.93zm.49 42c-.21 1.29-.45 2.59-.71 3.87a1.5 1.5 0 0 0 1.16 1.78 1.55 1.55 0 0 0 .31 0 1.5 1.5 0 0 0 1.46-1.19c.28-1.33.53-2.68.74-4a1.5 1.5 0 0 0-3-.48zm2.93-28.14a1.5 1.5 0 1 0-3 .49c.21 1.29.4 2.6.55 3.9a1.49 1.49 0 0 0 1.49 1.32h.17a1.5 1.5 0 0 0 1.32-1.66c-.16-1.35-.31-2.71-.53-4.05zm1.07 18.46c.07-1.35.1-2.72.1-4.06v-.2a1.55 1.55 0 0 0-1.51-1.5 1.5 1.5 0 0 0-1.49 1.51v.18c0 1.31 0 2.63-.09 3.94a1.5 1.5 0 0 0 1.43 1.56h.07a1.49 1.49 0 0 0 1.49-1.43zm-11.77-41.91a1.51 1.51 0 0 0 1.36.86 1.61 1.61 0 0 0 .64-.14 1.51 1.51 0 0 0 .72-2c-.58-1.22-.43-1-1.06-2.18a1.5 1.5 0 1 0-2.65 1.4c.61 1.15.44.88.99 2.06zM65.26 16.38a1.39 1.39 0 0 0 .53-.1c1.23-.46 2.47-.9 3.71-1.31a1.5 1.5 0 1 0-.93-2.85c-1.29.42-2.58.88-3.84 1.36a1.5 1.5 0 0 0 .53 2.9zM62.3 174.79a1.5 1.5 0 0 0-1.19 2.76c1.24.53 2.51 1 3.78 1.53a1.46 1.46 0 0 0 .53.1 1.5 1.5 0 0 0 .53-2.9c-1.22-.47-2.45-.97-3.65-1.49zm85.62-146.72a1.53 1.53 0 0 0 .91.3 1.5 1.5 0 0 0 .91-2.69 92.07 92.07 0 0 0-3.31-2.39 1.5 1.5 0 0 0-1.7 2.47c1.07.74 2.15 1.51 3.19 2.31zm-90.46-9.78a1.5 1.5 0 0 0-2-.64c-1.2.62-1.26.62-2.43 1.3a1.5 1.5 0 0 0 .75 2.8 1.44 1.44 0 0 0 .75-.21c1.13-.65 1.15-.62 2.31-1.23a1.49 1.49 0 0 0 .62-2.02zm113.17 123.22a1.5 1.5 0 0 0 2.06-.53c.68-1.17.86-1.28 1.49-2.48a1.5 1.5 0 0 0-2.66-1.4c-.61 1.16-.76 1.23-1.42 2.36a1.5 1.5 0 0 0 .53 2.05zM48.52 170.85c1.15.73 2.32 1.45 3.49 2.12a1.53 1.53 0 0 0 .75.2 1.5 1.5 0 0 0 .75-2.8c-1.13-.65-2.26-1.34-3.37-2.05a1.5 1.5 0 0 0-1.62 2.53zM8.39 85.17c-.17 1.34-.31 2.71-.41 4a1.5 1.5 0 0 0 1.38 1.62h.12A1.5 1.5 0 0 0 11 89.46c.1-1.3.24-2.62.4-3.92a1.5 1.5 0 0 0-3-.37zM8 103.47a1.51 1.51 0 0 0 1.5 1.38h.12a1.49 1.49 0 0 0 1.38-1.62c-.1-1.3-.18-2.63-.22-3.93a1.5 1.5 0 1 0-3 .1c.03 1.35.11 2.72.22 4.07zM11.69 77a1.51 1.51 0 0 0 1.46-1.14c.31-1.27.65-2.55 1-3.8a1.5 1.5 0 0 0-2.88-.85c-.38 1.3-.74 2.62-1.06 3.94A1.51 1.51 0 0 0 11.33 77a1.47 1.47 0 0 0 .36 0zm15.9 72.79a1.49 1.49 0 0 0-.22 2.1C28.22 153 29.11 154 30 155a1.49 1.49 0 0 0 1.12.51 1.52 1.52 0 0 0 1-.38 1.5 1.5 0 0 0 .13-2.12c-.87-1-1.73-2-2.55-3a1.49 1.49 0 0 0-2.11-.22zm135.77 3.4a1.47 1.47 0 0 0 1.15-.54c.87-1 1.72-2.12 2.53-3.2a1.5 1.5 0 1 0-2.4-1.8c-.78 1-1.6 2.08-2.44 3.09a1.49 1.49 0 0 0 1.16 2.45zm-141.93-9.56a1.5 1.5 0 0 0 1.27.69A1.49 1.49 0 0 0 24 142c-.7-1.1.16.42-.48-.71a1.5 1.5 0 0 0-2.61 1.49c.63 1.22-.2-.3.52.85zm-11.15-26.1a1.5 1.5 0 0 0 1.45 1.14 1.47 1.47 0 0 0 .36 0 1.5 1.5 0 0 0 1.1-1.82c-.31-1.27-.6-2.56-.85-3.84a1.5 1.5 0 0 0-2.95.58c.27 1.29.61 2.63.89 3.94zm15.41-72.29a1.48 1.48 0 0 0-2.08.37c-.78 1.11-1.54 2.25-2.26 3.39a1.5 1.5 0 1 0 2.53 1.61c.7-1.11 1.44-2.21 2.19-3.28a1.51 1.51 0 0 0-.38-2.09zM40 29.84a1.5 1.5 0 0 0 1.16.55 1.56 1.56 0 0 0 1-.34c1-.83 2-1.65 3.1-2.43a1.5 1.5 0 0 0-1.79-2.4c-1.08.8-2.16 1.65-3.21 2.51a1.49 1.49 0 0 0-.26 2.11zm-7.85 9.75c.87-1 1.77-2 2.68-2.88a1.5 1.5 0 0 0-2.16-2.09c-.94 1-1.87 2-2.76 3a1.48 1.48 0 0 0 .09 2.1 1.45 1.45 0 0 0 1 .38 1.47 1.47 0 0 0 1.15-.51zm110.21 132a1.46 1.46 0 0 0 .8-.23 94.6 94.6 0 0 0 3.4-2.23 1.5 1.5 0 0 0-1.71-2.47c-1.07.74-2.18 1.47-3.28 2.16a1.5 1.5 0 0 0 .79 2.77zM157.63 158a1.49 1.49 0 0 0-2.12 0c-.94.9-1.92 1.8-2.9 2.66a1.49 1.49 0 0 0-.14 2.12 1.5 1.5 0 0 0 2.11.14c1-.9 2-1.82 3-2.76a1.51 1.51 0 0 0 .05-2.16zm.56-120.76a1.5 1.5 0 1 0 2.17-2.07c-.93-1-1.9-1.94-2.88-2.88a1.5 1.5 0 1 0-2.07 2.17c.94.9 1.88 1.84 2.78 2.78zM14.8 131a1.49 1.49 0 0 0 1.38.91 1.59 1.59 0 0 0 .59-.12 1.51 1.51 0 0 0 .79-2c-.52-1.19-1-2.42-1.46-3.64a1.5 1.5 0 1 0-2.81 1.05c.47 1.32.98 2.59 1.51 3.8zm3.61-73.79a1.5 1.5 0 0 0-2 .7c-.58 1.22-1.15 2.47-1.68 3.72a1.5 1.5 0 0 0 .79 2 1.52 1.52 0 0 0 .59.12 1.5 1.5 0 0 0 1.38-.91 89.72 89.72 0 0 1 1.62-3.6 1.5 1.5 0 0 0-.7-2.03zm18.83 59.58h6a1 1 0 0 0 0-2h-6a1 1 0 1 0 0 2zm40.93-1a1 1 0 0 0-1-1H64.45a1 1 0 0 0 0 2h12.72a1 1 0 0 0 1-1zm50.88 0a1 1 0 0 0-1-1h-12.72a1 1 0 0 0 0 2h12.72a1 1 0 0 0 1-1zm-47.64 1h10.52a1 1 0 0 0 0-2H81.41a1 1 0 0 0 0 2zm15.96-1a1 1 0 0 0 1 1h12.72a1 1 0 0 0 0-2H98.37a1 1 0 0 0-1 1zm41.56 0a1 1 0 0 0 1 1H145a1 1 0 0 0 0-2h-5.09a1 1 0 0 0-.98 1zm-77.72 0a1 1 0 0 0-1-1h-8.78a1 1 0 1 0 0 2h8.78a1 1 0 0 0 1-1zm88.05 1h6a1 1 0 0 0 0-2h-6a1 1 0 0 0 0 2zm-100.38 34.5h3.72a1 1 0 0 0 0-2h-3.72a1 1 0 1 0 0 2zm74.72 0h10.08a1 1 0 0 0 0-2H123.6a1 1 0 0 0 0 2zm-20.44-1a1 1 0 0 0-1-1H90.34a1 1 0 0 0 0 2h11.82a1 1 0 0 0 1-1zm-18.06 0a1 1 0 0 0-1-1h-9.52a1 1 0 0 0 0 2h9.52a1 1 0 0 0 1-1zm-13.46 0a1 1 0 0 0-1-1H58.82a1 1 0 1 0 0 2h11.82a1 1 0 0 0 1-1zm47.28 0a1 1 0 0 0-1-1H106.1a1 1 0 0 0 0 2h11.82a1 1 0 0 0 1-1zm18.7 1h6a1 1 0 0 0 0-2h-6a1 1 0 0 0 0 2zm-95.35-68.8a6.55 6.55 0 0 0-.75-4.92.38.38 0 0 0-.5-.13l-1.87 1.08A.39.39 0 0 0 39 79a4 4 0 0 1 .31 2.69A3.89 3.89 0 0 1 31.76 80a3.85 3.85 0 0 1 1.52-2.28.33.33 0 0 0 .11-.46l-1.16-1.8a.36.36 0 0 0-.53-.1 6.38 6.38 0 0 0-2.76 4.08 6.84 6.84 0 1 0 13.33 3.1z"}}),_c('rect',{staticClass:"a",attrs:{"x":"39.49","y":"60.33","width":"3","height":"13.3","rx":".36","transform":"rotate(-62.04 40.98 66.974)"}}),_c('path',{staticClass:"a",attrs:{"d":"M50.61 54.24l-.08.08-7.23-2.38a.36.36 0 0 0-.37.09l-1.71 1.86a.34.34 0 0 0 .15.58l13.43 4.29a.38.38 0 0 0 .37-.1l.13-.14a.36.36 0 0 0 .06-.38L50 45.09a.33.33 0 0 0-.6-.09l-1.71 1.86a.36.36 0 0 0-.06.38z"}}),_c('rect',{staticClass:"a",attrs:{"x":"60.93","y":"37.01","width":"3","height":"13.3","rx":".36","transform":"rotate(-32.9 62.45 43.856)"}}),_c('path',{staticClass:"a",attrs:{"d":"M71.48 38.56a6.82 6.82 0 0 0 8.63 4.37 6.54 6.54 0 0 0 3.82-3.18.38.38 0 0 0-.14-.5l-1.89-1a.39.39 0 0 0-.48.13A4 4 0 0 1 79.28 40a3.89 3.89 0 0 1-2.42-7.38 3.92 3.92 0 0 1 2.74.12.32.32 0 0 0 .45-.14l.95-1.92a.35.35 0 0 0-.18-.5 6.38 6.38 0 0 0-4.92-.26 6.85 6.85 0 0 0-4.42 8.64zm24.58-5.08a2.06 2.06 0 0 0-2 2.1 2 2 0 0 0 4.07-.06 2.07 2.07 0 0 0-2.07-2.04zM115 29.65l-2.13-.65a.37.37 0 0 0-.45.25l-3.51 12.08a.36.36 0 0 0 .24.45l6.87 2a.35.35 0 0 0 .44-.24l.58-2a.36.36 0 0 0-.24-.45l-4.35-1.26 2.84-9.75a.39.39 0 0 0-.29-.43z"}}),_c('rect',{staticClass:"a",attrs:{"x":"120.44","y":"40.35","width":"13.3","height":"3","rx":".36","transform":"rotate(-60.41 127.089 41.852)"}}),_c('path',{staticClass:"a",attrs:{"d":"M137.37 58.09a.46.46 0 0 0 .15.34l1.88 1.83a.44.44 0 0 0 .74-.25l.94-7.9 7.08-.88a.44.44 0 0 0 .24-.74l-1.71-1.67a.59.59 0 0 0-.39-.12l-6.7.82 3.49-3.52a.47.47 0 0 0 0-.65l-1.59-1.55a.45.45 0 0 0-.65 0l-8.65 8.86a.44.44 0 0 0 0 .64l1.59 1.56a.47.47 0 0 0 .65 0l4-4.05zm10.5 15.35l1.82-1a.35.35 0 0 0 .14-.49l-2.51-4.62 2.25-1.23 2.07 3.8a.36.36 0 0 0 .49.15l1.82-1a.37.37 0 0 0 .14-.49L152 64.77l2.07-1.13 2.52 4.62a.36.36 0 0 0 .49.15l1.81-1a.36.36 0 0 0 .15-.49L155.29 60a.36.36 0 0 0-.49-.14l-11 6a.37.37 0 0 0-.14.49l3.76 6.9a.36.36 0 0 0 .45.19zm16.45 10.36l-1.12-5.57a.36.36 0 0 0-.43-.28l-12.33 2.48a.37.37 0 0 0-.29.43l.45 2.21a.39.39 0 0 0 .43.29l4.75-1 .26 1.28-4.44 3.48a.34.34 0 0 0-.11.33L152 90a.36.36 0 0 0 .6.2l4.22-3.5a4.06 4.06 0 0 0 7.51-2.87zm-3.85 2a1.51 1.51 0 0 1-1.77-1.11l-.56-2.76 2.91-.58.55 2.75a1.44 1.44 0 0 1-1.13 1.69zM93.72 75.5a.91.91 0 0 0 1.2 1.37 20.77 20.77 0 0 0 4.28-5c.18-.31.68-1 1.42-.92a.91.91 0 0 0 1-.78.9.9 0 0 0-.78-1A3.22 3.22 0 0 0 97.63 71a19.49 19.49 0 0 1-3.91 4.5zM78.31 92.18a.91.91 0 0 0 1.28.12 25.6 25.6 0 0 1 3-2 .91.91 0 0 0 .41-1.23.93.93 0 0 0-1.23-.41 26.63 26.63 0 0 0-3.34 2.24.91.91 0 0 0-.12 1.28z"}}),_c('path',{staticClass:"a",attrs:{"d":"M86.9 73.49A55.18 55.18 0 0 0 84.39 81a23 23 0 0 0-.17 9.28.9.9 0 0 1-.11.62 35.63 35.63 0 0 0-2.32 4 1.13 1.13 0 0 0 .47 1.45 1.09 1.09 0 0 0 .54.14 1.1 1.1 0 0 0 1-.64c.35-.72 1-2.08 1.33-2.65a19.44 19.44 0 0 0 .93-2 3.06 3.06 0 0 0 0-1.78 18.5 18.5 0 0 1 .19-7.5 76.68 76.68 0 0 1 2.68-8.36c.27-.66.65-.87 1-.84s1.12.22.91 1.59c-.38 2.45-.91 5.56-1.09 6.61a2.13 2.13 0 0 0 .77 2.26 2.25 2.25 0 0 0 2.48-.41 46 46 0 0 0 7.71-6.56 18.35 18.35 0 0 0 3.63-5.52 1 1 0 0 1 1.2-.56c.25.07.55.4.34 1.1a24 24 0 0 1-6.66 9.24.79.79 0 0 0-.16 1.16.75.75 0 0 0 1.11 0 26.75 26.75 0 0 0 6.65-8.79 16.12 16.12 0 0 0 .8-2c.2-.57.64-.78 1-.71s.73.54.59 1.29a12.7 12.7 0 0 1-1 2.76 38.43 38.43 0 0 1-6.28 8.64.74.74 0 0 0 0 1.09c.36.34.78.19 1.16-.18a34.23 34.23 0 0 0 6.36-8.5.79.79 0 0 1 1-.5c.51.2.5 1.07 0 2a32.15 32.15 0 0 1-6.24 8.72.7.7 0 0 0 0 1c.3.26.78.25 1.22-.21a36.28 36.28 0 0 0 3.9-4.55.85.85 0 0 1 .88-.45c.44.08.51.5.37 1-.21.82-2.52 3.84-3.43 4.85-2.47 2.76-4.94 4.27-9.7 6.74a8.38 8.38 0 0 0-3.65 3c-.69 1.16-.89 1.54-1 1.68a1.16 1.16 0 0 0 .5 1.54 1.09 1.09 0 0 0 .49.11 1.11 1.11 0 0 0 1-.69l.86-1.5a6.52 6.52 0 0 1 2.8-2.47 27.45 27.45 0 0 0 9.55-6.65 32.06 32.06 0 0 0 3.48-4.76c1.33-2.24.63-4.16-.57-4.48a.16.16 0 0 1-.1-.23 11.83 11.83 0 0 0 1.53-3.55 2.25 2.25 0 0 0-1.68-2.9.15.15 0 0 1-.11-.19c.1-.37.2-.83.26-1.14a2.58 2.58 0 0 0-1.76-3.11 2.63 2.63 0 0 0-2.14.44.2.2 0 0 1-.28 0 1.68 1.68 0 0 0-1.19-.55 2.68 2.68 0 0 0-2.69 1.82 19.16 19.16 0 0 1-3.52 5 38.63 38.63 0 0 1-6.75 5.72c-.31.2-.75.15-.7-.27.09-.66.8-5.15.92-6.47.2-2.14-1-3.12-2.25-3.3-1.04-.12-2.66.18-3.55 2.61zm-3.03-6.11a.39.39 0 0 0-.53-.22 4.19 4.19 0 0 0-1.09.78 4.07 4.07 0 0 0-.91 1 .4.4 0 0 0 .15.56c.49.36 2.93 1.8 3.53 2.08.12.06.27.13.41 0a.34.34 0 0 0 0-.4c-.15-.66-1.26-3.27-1.56-3.8zm-3.22 8.17c.55-.23 3.06-1.57 3.61-1.93.11-.07.25-.16.22-.35 0-.19-.2-.22-.33-.25-.63-.16-3.45-.57-4.05-.59a.4.4 0 0 0-.47.34 4.33 4.33 0 0 0 .1 1.33 4.53 4.53 0 0 0 .36 1.29.41.41 0 0 0 .56.16zm24.96 19.15c-.18 0-.24.17-.28.29a39.85 39.85 0 0 0-1 4 .39.39 0 0 0 .28.5 4.37 4.37 0 0 0 1.34 0 4 4 0 0 0 1.32-.22.4.4 0 0 0 .22-.54c-.17-.57-1.24-3.21-1.54-3.79-.08-.11-.16-.26-.34-.24zm4.55 2.04a.4.4 0 0 0 .58 0 4.43 4.43 0 0 0 .73-1.12 4.56 4.56 0 0 0 .5-1.24.4.4 0 0 0-.35-.47c-.58-.16-3.38-.62-4-.66-.13 0-.3 0-.38.14-.08.16 0 .29.11.4.36.54 2.35 2.57 2.81 2.95zm-10.07 68.68a1 1 0 0 0-1.26-.64l-1.58.51v-1.66a1 1 0 0 0-2 0v1.66l-1.58-.51a1 1 0 1 0-.62 1.9l1.58.51-1 1.34a1 1 0 0 0 .22 1.4 1 1 0 0 0 1.39-.22l1-1.34 1 1.34a1 1 0 1 0 1.61-1.18l-1-1.34 1.58-.51a1 1 0 0 0 .66-1.26zm11.34 0a1 1 0 0 0-1.26-.64l-1.58.51v-1.66a1 1 0 0 0-2 0v1.66l-1.58-.51a1 1 0 1 0-.62 1.9l1.58.51-1 1.34a1 1 0 0 0 .22 1.4 1 1 0 0 0 1.39-.22l1-1.34 1 1.34a1 1 0 0 0 .81.41 1 1 0 0 0 .81-1.59l-1-1.34 1.58-.51a1 1 0 0 0 .65-1.26zm-28.89 4.51a1 1 0 0 0 .59.19 1 1 0 0 0 .81-.41l1-1.34 1 1.34a1 1 0 0 0 .81.41 1 1 0 0 0 .58-.19 1 1 0 0 0 .22-1.4l-1-1.34 1.58-.51a1 1 0 0 0 .64-1.26 1 1 0 0 0-1.26-.64l-1.58.51v-1.66a1 1 0 0 0-2 0v1.66l-1.58-.51a1 1 0 0 0-1.26.64 1 1 0 0 0 .64 1.26l1.58.51-1 1.34a1 1 0 0 0 .23 1.4z"}})])
      }
    
      });
    
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/LcChopCivicLiker/LcChopCivicLiker.vue?vue&type=script&lang=js&
function LcChopCivicLikervue_type_script_lang_js_defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var LcChopCivicLikervue_type_script_lang_js_ = ({
  name: "lc-chop-civic-liker",
  components: {
    Chop: chop_civic_likerinline
  },
  mixins: [lc_chop({
    className: "lc-chop-civic-liker",
    defaultSize: 128,
    contentWiggleRotateZ: 5,
    valueWiggleRotateZ: 6,
    props: ["date", "text", "isBeta", "isTrial", "isTrialling"]
  })],
  props: {
    isFlashing: {
      type: [Boolean, String],
      default: false
    }
  },
  computed: {
    rootClass: function rootClass() {
      var className = this.$options.name;
      return [].concat(_toConsumableArray(this.mixinClass), [LcChopCivicLikervue_type_script_lang_js_defineProperty({}, "".concat(className, "--flashing"), this.isFlashing)]);
    },
    value: function value() {
      if (this.text) {
        return this.text;
      }

      if (this.isBeta) {
        return "LIKE";
      }

      if (this.isTrial) {
        return "TRIAL";
      }

      return this.dateValue;
    }
  }
});
// CONCATENATED MODULE: ./src/components/LcChopCivicLiker/LcChopCivicLiker.vue?vue&type=script&lang=js&
 /* harmony default export */ var LcChopCivicLiker_LcChopCivicLikervue_type_script_lang_js_ = (LcChopCivicLikervue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/LcChopCivicLiker/LcChopCivicLiker.vue?vue&type=style&index=0&lang=scss&
var LcChopCivicLikervue_type_style_index_0_lang_scss_ = __webpack_require__("7507");

// CONCATENATED MODULE: ./src/components/LcChopCivicLiker/LcChopCivicLiker.vue






/* normalize component */

var LcChopCivicLiker_component = normalizeComponent(
  LcChopCivicLiker_LcChopCivicLikervue_type_script_lang_js_,
  LcChopCivicLikervue_type_template_id_03071260_render,
  LcChopCivicLikervue_type_template_id_03071260_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LcChopCivicLiker = (LcChopCivicLiker_component.exports);
// CONCATENATED MODULE: ./src/components/LcChopCivicLiker/index.js


/* harmony default export */ var components_LcChopCivicLiker = (LcChopCivicLiker);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"27a05820-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/LcChopCivicLikerRect/LcChopCivicLikerRect.vue?vue&type=template&id=7f8ef233&
var LcChopCivicLikerRectvue_type_template_id_7f8ef233_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.rootClass,style:(_vm.rootStyle)},[_c('div',{staticClass:"lc-chop__content",style:(_vm.contentStyle)},[_c('chop'),(_vm.isBeta)?_c('quota-chop'):(_vm.isTrial)?_c('trial-chop'):_vm._e(),_c('span',{staticClass:"lc-chop__content__value",style:(_vm.valueStyle)},[_vm._v("\n      "+_vm._s(_vm.value)+"\n    ")])],1)])}
var LcChopCivicLikerRectvue_type_template_id_7f8ef233_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/LcChopCivicLikerRect/LcChopCivicLikerRect.vue?vue&type=template&id=7f8ef233&

// CONCATENATED MODULE: ./src/assets/chop/civic-liker-rect.svg?inline

      /* harmony default export */ var civic_liker_rectinline = ({
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 316.7 191.31","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M264.37 44.9a1 1 0 0 1-1-1V39a1 1 0 1 1 2 0v4.9a1 1 0 0 1-1 1z"}}),_c('path',{attrs:{"d":"M264.37 44.91a1.18 1.18 0 0 1-.31 0l-4.63-1.51a1 1 0 1 1 .62-1.9l4.63 1.5a1 1 0 0 1 .64 1.26 1 1 0 0 1-.95.65z"}}),_c('path',{attrs:{"d":"M261.51 48.85a1.06 1.06 0 0 1-.59-.19 1 1 0 0 1-.22-1.4l2.86-3.94a1 1 0 0 1 1.4-.22 1 1 0 0 1 .22 1.39l-2.86 3.94a1 1 0 0 1-.81.42z"}}),_c('path',{attrs:{"d":"M267.24 48.85a1 1 0 0 1-.81-.42l-2.87-3.94a1 1 0 0 1 .23-1.39 1 1 0 0 1 1.39.22l2.87 3.94a1 1 0 0 1-.22 1.4 1.09 1.09 0 0 1-.59.19z"}}),_c('path',{attrs:{"d":"M264.37 44.91a1 1 0 0 1-.31-2l4.64-1.5a1 1 0 0 1 .62 1.9l-4.64 1.51a1.06 1.06 0 0 1-.31.09zm18.2-.01a1 1 0 0 1-1-1V39a1 1 0 0 1 2 0v4.9a1 1 0 0 1-1 1z"}}),_c('path',{attrs:{"d":"M282.57 44.91a1.18 1.18 0 0 1-.31 0l-4.63-1.51a1 1 0 1 1 .62-1.9l4.63 1.5a1 1 0 0 1-.31 2z"}}),_c('path',{attrs:{"d":"M279.71 48.85a1.06 1.06 0 0 1-.59-.19 1 1 0 0 1-.22-1.4l2.86-3.94a1 1 0 0 1 1.4-.22 1 1 0 0 1 .22 1.39l-2.86 3.94a1 1 0 0 1-.81.42z"}}),_c('path',{attrs:{"d":"M285.44 48.85a1 1 0 0 1-.81-.42l-2.87-3.94a1 1 0 0 1 1.62-1.17l2.87 3.94a1 1 0 0 1-.23 1.4 1 1 0 0 1-.58.19z"}}),_c('path',{attrs:{"d":"M282.57 44.91a1 1 0 0 1-.31-2l4.64-1.5a1 1 0 0 1 .62 1.9l-4.64 1.51a1.12 1.12 0 0 1-.31.09zm-36.4-.01a1 1 0 0 1-1-1V39a1 1 0 0 1 2 0v4.9a1 1 0 0 1-1 1z"}}),_c('path',{attrs:{"d":"M246.17 44.91a1.18 1.18 0 0 1-.31 0l-4.63-1.51a1 1 0 1 1 .62-1.9l4.63 1.5a1 1 0 0 1-.31 2z"}}),_c('path',{attrs:{"d":"M243.31 48.85a1.09 1.09 0 0 1-.59-.19 1 1 0 0 1-.22-1.4l2.86-3.94a1 1 0 0 1 1.4-.22 1 1 0 0 1 .22 1.39l-2.86 3.94a1 1 0 0 1-.81.42z"}}),_c('path',{attrs:{"d":"M249 48.85a1 1 0 0 1-.81-.42l-2.87-3.94a1 1 0 0 1 .23-1.39 1 1 0 0 1 1.39.22l2.87 3.94a1 1 0 0 1-.22 1.4 1.09 1.09 0 0 1-.59.19z"}}),_c('path',{attrs:{"d":"M246.17 44.91a1 1 0 0 1-.31-2l4.64-1.5a1 1 0 0 1 .62 1.9l-4.64 1.51a1.06 1.06 0 0 1-.31.09zM78.94 154a6.37 6.37 0 0 1 4.59 1.77.35.35 0 0 1 0 .53l-1.48 1.54a.34.34 0 0 1-.48 0 3.85 3.85 0 0 0-2.56-1 3.89 3.89 0 0 0 0 7.77 4 4 0 0 0 2.54-.91.39.39 0 0 1 .5 0l1.48 1.58a.38.38 0 0 1 0 .51 6.52 6.52 0 0 1-4.61 1.84 6.84 6.84 0 1 1 0-13.68zm12.59.5a.37.37 0 0 1 .36-.36h2.28a.37.37 0 0 1 .36.36v12.58a.37.37 0 0 1-.36.36h-2.28a.37.37 0 0 1-.36-.36zm10.26.14a.34.34 0 0 1 .33-.5h2.52a.4.4 0 0 1 .33.21l3.13 6.94h.11l3.14-6.94a.38.38 0 0 1 .32-.21h2.53a.34.34 0 0 1 .32.5l-6 12.78a.37.37 0 0 1-.33.21H108a.35.35 0 0 1-.32-.21zm19.99-.14a.37.37 0 0 1 .36-.36h2.28a.37.37 0 0 1 .36.36v12.58a.37.37 0 0 1-.36.36h-2.28a.37.37 0 0 1-.36-.36zm17.86-.5a6.39 6.39 0 0 1 4.6 1.77.35.35 0 0 1 0 .53l-1.49 1.54a.33.33 0 0 1-.47 0 3.86 3.86 0 0 0-2.57-1 3.89 3.89 0 0 0 0 7.77 4 4 0 0 0 2.55-.91.38.38 0 0 1 .49 0l1.48 1.58a.37.37 0 0 1 0 .51 6.56 6.56 0 0 1-4.62 1.84 6.84 6.84 0 1 1 0-13.68zm12.79 8.62a2 2 0 0 1 2-2.07 2.07 2.07 0 0 1 2.07 2.07 2 2 0 0 1-2.07 2 2 2 0 0 1-2-2zm13.22-8.12a.36.36 0 0 1 .36-.36h2.26a.37.37 0 0 1 .36.36v10.15h4.52a.37.37 0 0 1 .37.36v2.07a.37.37 0 0 1-.37.36H166a.36.36 0 0 1-.36-.36zm15.41 0a.37.37 0 0 1 .36-.36h2.28a.37.37 0 0 1 .36.36v12.58a.37.37 0 0 1-.36.36h-2.28a.37.37 0 0 1-.36-.36zm11.94.1a.45.45 0 0 1 .46-.46h2.22a.46.46 0 0 1 .45.46v5l4.22-5.27a.61.61 0 0 1 .36-.19h2.4a.44.44 0 0 1 .34.71l-4.45 5.56 4.85 6.31a.44.44 0 0 1-.36.7h-2.63a.51.51 0 0 1-.34-.13l-4.39-6V167a.45.45 0 0 1-.45.45h-2.22a.45.45 0 0 1-.46-.45zm18.52-.1a.36.36 0 0 1 .36-.36h7.86a.36.36 0 0 1 .36.36v2.08a.36.36 0 0 1-.36.36h-5.26v2.35h4.33a.37.37 0 0 1 .36.36v2.07a.36.36 0 0 1-.36.36h-4.33v2.57h5.26a.36.36 0 0 1 .36.36v2.07a.36.36 0 0 1-.36.36h-7.86a.36.36 0 0 1-.36-.36zm16.83 0a.36.36 0 0 1 .36-.36h5.68a4.14 4.14 0 0 1 4.14 4.11 4.19 4.19 0 0 1-2.81 3.82l2.6 4.82a.36.36 0 0 1-.32.55h-2.53a.34.34 0 0 1-.3-.17l-2.53-5h-1.31v4.84a.37.37 0 0 1-.36.36h-2.26a.36.36 0 0 1-.36-.36zm5.79 5.32a1.53 1.53 0 0 0 1.45-1.52 1.46 1.46 0 0 0-1.45-1.44h-2.81v3zM8.83 153a2.5 2.5 0 0 1-2.5-2.5V8.88a2.49 2.49 0 0 1 2.5-2.5H39a2.5 2.5 0 0 1 0 5H11.33v139.1a2.5 2.5 0 0 1-2.5 2.52z"}}),_c('path',{attrs:{"d":"M307.87 184.94H8.83a2.5 2.5 0 0 1-2.5-2.5v-21a2.5 2.5 0 0 1 5 0v18.46h294v-58.42a2.5 2.5 0 0 1 5 0v61a2.5 2.5 0 0 1-2.46 2.46zm0-72.46a2.5 2.5 0 0 1-2.5-2.5V29a2.5 2.5 0 0 1 5 0v81a2.5 2.5 0 0 1-2.5 2.48zm0-90.48a2.5 2.5 0 0 1-2.5-2.5v-8.1H87a2.5 2.5 0 1 1 0-5h220.87a2.49 2.49 0 0 1 2.5 2.5v10.6a2.5 2.5 0 0 1-2.5 2.5zM75 11.38H50.54a2.5 2.5 0 1 1 0-5H75a2.5 2.5 0 0 1 0 5zm-19 45.7H31.74a1.5 1.5 0 0 1-1.5-1.5v-4.86a1.5 1.5 0 0 1 3 0v3.36h21.27V32.8H33.24v3.36a1.5 1.5 0 0 1-3 0V31.3a1.5 1.5 0 0 1 1.5-1.5H56a1.5 1.5 0 0 1 1.5 1.5v24.28a1.5 1.5 0 0 1-1.5 1.5z"}}),_c('path',{attrs:{"d":"M42.37 51.15a1.53 1.53 0 0 1-1.06-.44 1.51 1.51 0 0 1 0-2.12l5.08-5.08-4.87-4.88a1.49 1.49 0 0 1 0-2.12 1.51 1.51 0 0 1 2.12 0l5.93 5.94a1.5 1.5 0 0 1 0 2.12l-6.14 6.14a1.49 1.49 0 0 1-1.06.44z"}}),_c('path',{attrs:{"d":"M48.51 45H28.24a1.5 1.5 0 0 1 0-3h20.27a1.5 1.5 0 0 1 0 3zm36.03 96H8.21a1 1 0 0 1 0-2h76.33a1 1 0 0 1 0 2zm73 0h-65a1 1 0 1 1 0-2h65a1 1 0 0 1 0 2zm150.67 0H166.54a1 1 0 0 1 0-2h141.67a1 1 0 0 1 0 2zm-2.76 48.81a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.25 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.25 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.25 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-16.51 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.25 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.25 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.25 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.25 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.25 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.25 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.25 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.25 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.25 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.3 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.21 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-16.53 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.23 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.25 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zM305.45 1.5A1.5 1.5 0 0 1 307 0a1.5 1.5 0 0 1 1.5 1.5A1.5 1.5 0 0 1 307 3a1.5 1.5 0 0 1-1.55-1.5zm-8.25 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.25 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.25 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.25 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.25 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.25 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.25 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.25 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.25 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.25 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.25 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.25 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zM66 1.5A1.5 1.5 0 0 1 67.54 0 1.5 1.5 0 0 1 69 1.5 1.5 1.5 0 0 1 67.54 3 1.5 1.5 0 0 1 66 1.5zm-8.21 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0A1.5 1.5 0 0 1 51 0a1.5 1.5 0 0 1 1.5 1.5A1.5 1.5 0 0 1 51 3a1.5 1.5 0 0 1-1.47-1.5zM33 1.5A1.5 1.5 0 0 1 34.52 0 1.5 1.5 0 0 1 36 1.5 1.5 1.5 0 0 1 34.52 3 1.5 1.5 0 0 1 33 1.5zm-8.23 0a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm-8.26 0A1.5 1.5 0 0 1 18 0a1.5 1.5 0 0 1 1.5 1.5A1.5 1.5 0 0 1 18 3a1.5 1.5 0 0 1-1.49-1.5zm-8.25 0A1.5 1.5 0 0 1 9.76 0a1.5 1.5 0 0 1 1.5 1.5A1.5 1.5 0 0 1 9.76 3a1.5 1.5 0 0 1-1.5-1.5zM0 189.81a1.5 1.5 0 0 1 1.5-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm0-8.19a1.5 1.5 0 0 1 1.49-1.5 1.5 1.5 0 0 1 1.5 1.5H3a1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm0-8.18a1.5 1.5 0 0 1 1.49-1.5 1.5 1.5 0 0 1 1.5 1.5H3a1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm0-24.57a1.5 1.5 0 0 1 1.49-1.5 1.5 1.5 0 0 1 1.5 1.5H3a1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm0-8.18a1.5 1.5 0 0 1 1.49-1.5 1.5 1.5 0 0 1 1.5 1.5H3a1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm0-8.19a1.5 1.5 0 0 1 1.49-1.5A1.5 1.5 0 0 1 3 132.5a1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm0-16.38a1.5 1.5 0 0 1 1.49-1.5 1.5 1.5 0 0 1 1.5 1.5H3a1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm0-8.18a1.5 1.5 0 0 1 1.49-1.5 1.5 1.5 0 0 1 1.5 1.5H3a1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm0-8.19a1.5 1.5 0 0 1 1.49-1.5A1.5 1.5 0 0 1 3 99.75a1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm0-8.19a1.5 1.5 0 0 1 1.49-1.5A1.5 1.5 0 0 1 3 91.56a1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm0-8.19a1.5 1.5 0 0 1 1.49-1.5A1.5 1.5 0 0 1 3 83.37a1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm0-8.18a1.5 1.5 0 0 1 1.49-1.5A1.5 1.5 0 0 1 3 75.19a1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zM0 67a1.5 1.5 0 0 1 1.49-1.5A1.5 1.5 0 0 1 3 67a1.5 1.5 0 0 1-1.5 1.5A1.5 1.5 0 0 1 0 67zm0-8.19a1.5 1.5 0 0 1 1.49-1.5A1.5 1.5 0 0 1 3 58.81a1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm0-8.19a1.5 1.5 0 0 1 1.49-1.5A1.5 1.5 0 0 1 3 50.62a1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm0-8.18a1.5 1.5 0 0 1 1.49-1.5A1.5 1.5 0 0 1 3 42.44a1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm0-8.19a1.5 1.5 0 0 1 1.49-1.5A1.5 1.5 0 0 1 3 34.25a1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm0-8.19a1.5 1.5 0 0 1 1.49-1.5A1.5 1.5 0 0 1 3 26.06a1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zm0-8.19a1.5 1.5 0 0 1 1.49-1.5A1.5 1.5 0 0 1 3 17.87a1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.5-1.5zM0 1.5A1.5 1.5 0 0 1 1.49 0 1.5 1.5 0 0 1 3 1.5 1.5 1.5 0 0 1 1.49 3 1.5 1.5 0 0 1 0 1.5zm313.71 180.12a1.5 1.5 0 0 1 1.49-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.49-1.5zm0-8.18a1.5 1.5 0 0 1 1.49-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.49-1.5zm0-8.19a1.5 1.5 0 0 1 1.49-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.49-1.5zm0-8.19a1.5 1.5 0 0 1 1.49-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.49-1.5zm0-8.19a1.5 1.5 0 0 1 1.49-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.49-1.5zm0-8.18a1.5 1.5 0 0 1 1.49-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.49-1.5zm0-8.19a1.5 1.5 0 0 1 1.49-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.49-1.5zm0-8.19a1.5 1.5 0 0 1 1.49-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.49-1.5zm0-16.37a1.5 1.5 0 0 1 1.49-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.49-1.5zm0-8.19a1.5 1.5 0 0 1 1.49-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.49-1.5zm0-8.19a1.5 1.5 0 0 1 1.49-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.49-1.5zm0-8.19a1.5 1.5 0 0 1 1.49-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.49-1.5zm0-8.18a1.5 1.5 0 0 1 1.49-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.49-1.5zm0-8.19a1.5 1.5 0 0 1 1.49-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.49-1.5zm0-8.19a1.5 1.5 0 0 1 1.49-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.49-1.5zm0-8.19a1.5 1.5 0 0 1 1.49-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.49-1.5zm0-8.18a1.5 1.5 0 0 1 1.49-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.49-1.5zm0-8.19a1.5 1.5 0 0 1 1.49-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.49-1.5zm0-16.38a1.5 1.5 0 0 1 1.49-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.49-1.5zm0-8.18a1.5 1.5 0 0 1 1.49-1.5 1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.49-1.5zm0-8.19A1.5 1.5 0 0 1 315.2 0a1.5 1.5 0 0 1 1.5 1.5 1.5 1.5 0 0 1-1.5 1.5 1.5 1.5 0 0 1-1.49-1.5zm-26.5 121h-5a1 1 0 0 1 0-2h3v-2.42a1 1 0 1 1 2 0zm-15 0h-7a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2zm-14 0h-7a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2zm-14 0h-7a1 1 0 0 1 0-2h7a1 1 0 1 1 0 2zm-14 0h-7a1 1 0 0 1 0-2h7a1 1 0 1 1 0 2zm-14 0h-7a1 1 0 0 1 0-2h7a1 1 0 1 1 0 2zm-14 0h-3.5a1 1 0 0 1 0-2h3.5a1 1 0 1 1 0 2zm-14 0h-7a1 1 0 0 1 0-2h7a1 1 0 1 1 0 2zm-14 0h-5.5a1 1 0 0 1 0-2h5.5a1 1 0 1 1 0 2zm-17.67 0h-3.33a1 1 0 0 1 0-2h3.33a1 1 0 0 1 0 2zm-10.33 0h-7a1 1 0 0 1 0-2h7a1 1 0 1 1 0 2zm-14 0h-7a1 1 0 1 1 0-2h7a1 1 0 0 1 0 2zm-14 0h-7a1 1 0 1 1 0-2h7a1 1 0 0 1 0 2zm-14 0h-5.5a1 1 0 1 1 0-2h5.5a1 1 0 0 1 0 2zm-28 0h-7a1 1 0 1 1 0-2h7a1 1 0 0 1 0 2zm-14 0h-5a1 1 0 0 1 0-2h5a1 1 0 1 1 0 2zm-14 0h-7a1 1 0 0 1 0-2h7a1 1 0 1 1 0 2zM30.5 112.21a1 1 0 0 1-1-1v-7a1 1 0 1 1 2 0v7a1 1 0 0 1-1 1zm255.71-.13a1 1 0 0 1-1-1v-7a1 1 0 1 1 2 0v7a1 1 0 0 1-1 1zM30.5 96.71a1 1 0 0 1-1-1v-5.5a1 1 0 0 1 2 0v5.5a1 1 0 0 1-1 1zm255.71 1.37a1 1 0 0 1-1-1v-4.5a1 1 0 1 1 2 0v4.5a1 1 0 0 1-1 1zM30.5 84.21a1 1 0 0 1-1-1v-5.5a1 1 0 0 1 2 0v5.5a1 1 0 0 1-1 1zm255.71-1.13a1 1 0 0 1-1-1v-4.5a1 1 0 1 1 2 0v4.5a1 1 0 0 1-1 1zm-5.43-7.58h-7a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2zm-14 0h-4a1 1 0 0 1 0-2h4a1 1 0 0 1 0 2zm-14 0h-7a1 1 0 1 1 0-2h7a1 1 0 0 1 0 2zm-14 0h-5.5a1 1 0 1 1 0-2h5.5a1 1 0 0 1 0 2zm-28 0h-7a1 1 0 1 1 0-2h7a1 1 0 0 1 0 2zm-15.5 0h-5.5a1 1 0 1 1 0-2h5.5a1 1 0 0 1 0 2zm-12.5 0h-7a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2zm-14 0h-7a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2zm-14 0h-4.5a1 1 0 0 1 0-2h4.5a1 1 0 0 1 0 2zm-14 0h-7a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2zm-15.5 0h-5.5a1 1 0 0 1 0-2h5.5a1 1 0 0 1 0 2zm-12.5 0h-5.5a1 1 0 0 1 0-2h5.5a1 1 0 0 1 0 2zm-14 0h-7a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2zm-14 0h-7a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2zm-14 0h-7a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2zm-14 0h-7a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2zm-14 0h-7a1 1 0 0 1 0-2h7a1 1 0 0 1 0 2z"}})])
      }
    
      });
    
// CONCATENATED MODULE: ./src/assets/chop/civic-liker-rect_quota.svg?inline

      /* harmony default export */ var civic_liker_rect_quotainline = ({
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 316.7 191.3"}},[_c('path',{attrs:{"d":"M83.2 35.6c4.4 0 7.9 3.5 7.9 7.9 0 2.9-1.7 5.5-4.1 6.9l2.8 4.4c.2.3 0 .7-.4.7h-3c-.2 0-.3-.1-.4-.2l-2.3-3.9H83c-4.4 0-7.9-3.5-7.9-7.9.2-4.3 3.7-7.9 8.1-7.9zm0 12.3c2.4 0 4.4-2 4.4-4.4 0-2.4-2-4.4-4.4-4.4-2.4 0-4.4 2-4.4 4.4 0 2.5 2 4.4 4.4 4.4zm17-11.6c0-.2.2-.4.4-.4h2.7c.2 0 .4.2.4.4v8.9c0 1.5 1.1 2.8 2.7 2.8s2.8-1.2 2.8-2.8v-8.9c0-.2.2-.4.4-.4h2.7c.2 0 .4.2.4.4v9.1c0 3.3-2.8 6.1-6.3 6.1s-6.2-2.8-6.2-6.1v-9.1zm29.5-.7c4.4 0 7.9 3.5 7.9 7.9s-3.5 7.9-7.9 7.9-7.9-3.5-7.9-7.9c0-4.3 3.5-7.9 7.9-7.9zm0 12.3c2.4 0 4.4-2 4.4-4.4 0-2.4-2-4.4-4.4-4.4-2.4 0-4.4 2-4.4 4.4 0 2.5 2 4.4 4.4 4.4zm19-8.8h-3.1c-.2 0-.4-.2-.4-.4v-2.4c0-.2.2-.4.4-.4h9.8c.2 0 .4.2.4.4v2.4c0 .2-.2.4-.4.4h-3.1v11.8c0 .2-.2.4-.4.4h-2.6c-.2 0-.4-.2-.4-.4V39.1zm13.1 11.6l6.9-14.8c.1-.1.2-.2.4-.2h.2c.2 0 .3.1.4.2l6.9 14.8c.1.3 0 .6-.4.6h-2.4c-.4 0-.6-.1-.8-.6l-.8-1.7h-6l-.8 1.8c-.1.3-.4.5-.8.5h-2.4c-.3-.1-.5-.3-.4-.6zm9.1-4.7l-1.7-3.6-1.7 3.6h3.4z"}})])
      }
    
      });
    
// CONCATENATED MODULE: ./src/assets/chop/civic-liker-rect_trial.svg?inline

      /* harmony default export */ var civic_liker_rect_trialinline = ({
        functional: true,
        render: 
      function render(_h, _vm) {
        var _c=_vm._c;return _c('svg',{class:[_vm.data.class, _vm.data.staticClass],style:([_vm.data.style, _vm.data.staticStyle]),attrs:{"viewBox":"0 0 316.7 191.31","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M78.88 39.33h-3.15a.42.42 0 0 1-.42-.42v-2.39a.42.42 0 0 1 .42-.42h9.77a.42.42 0 0 1 .42.42v2.39a.42.42 0 0 1-.42.42h-3.15v11.75a.44.44 0 0 1-.42.42h-2.64a.43.43 0 0 1-.41-.42zm15.84-2.81a.42.42 0 0 1 .42-.42h6.57a4.7 4.7 0 0 1 1.54 9.17l3 5.59a.42.42 0 0 1-.38.64H103a.39.39 0 0 1-.35-.2l-2.93-5.83h-1.55v5.61a.44.44 0 0 1-.42.42h-2.61a.42.42 0 0 1-.42-.42zm6.71 6.16a1.77 1.77 0 0 0 1.67-1.76 1.69 1.69 0 0 0-1.67-1.68h-3.26v3.44zm14.63-6.16a.44.44 0 0 1 .42-.42h2.64a.44.44 0 0 1 .42.42v14.56a.44.44 0 0 1-.42.42h-2.64a.44.44 0 0 1-.42-.42zm11.88 14.41l6.89-14.81a.44.44 0 0 1 .37-.24h.22a.46.46 0 0 1 .38.24l6.88 14.81a.38.38 0 0 1-.37.57h-2.44c-.4 0-.58-.13-.77-.55l-.8-1.74h-6l-.77 1.79a.81.81 0 0 1-.79.53h-2.42a.39.39 0 0 1-.38-.6zm9-4.71l-1.67-3.63-1.65 3.63zm14.15-9.7a.42.42 0 0 1 .42-.42h2.61a.44.44 0 0 1 .42.42v11.75h5.24a.41.41 0 0 1 .42.41v2.4a.42.42 0 0 1-.42.42h-8.27a.42.42 0 0 1-.42-.42z"}})])
      }
    
      });
    
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/LcChopCivicLikerRect/LcChopCivicLikerRect.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var LcChopCivicLikerRectvue_type_script_lang_js_ = ({
  name: "lc-chop-civic-liker-rect",
  components: {
    Chop: civic_liker_rectinline,
    QuotaChop: civic_liker_rect_quotainline,
    TrialChop: civic_liker_rect_trialinline
  },
  mixins: [lc_chop({
    className: "lc-chop-civic-liker-rect",
    defaultSize: 210,
    contentWiggleRotateZ: 3,
    valueWiggleRotateZ: 4,
    props: ["date", "text", "isTrial", "isTrialling", "isBeta"]
  })],
  computed: {
    value: function value() {
      if (this.text) {
        return this.text;
      }

      if (this.isBeta) {
        return "LIMITED";
      }

      return this.dateValue;
    }
  }
});
// CONCATENATED MODULE: ./src/components/LcChopCivicLikerRect/LcChopCivicLikerRect.vue?vue&type=script&lang=js&
 /* harmony default export */ var LcChopCivicLikerRect_LcChopCivicLikerRectvue_type_script_lang_js_ = (LcChopCivicLikerRectvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/LcChopCivicLikerRect/LcChopCivicLikerRect.vue?vue&type=style&index=0&lang=scss&
var LcChopCivicLikerRectvue_type_style_index_0_lang_scss_ = __webpack_require__("a41e");

// CONCATENATED MODULE: ./src/components/LcChopCivicLikerRect/LcChopCivicLikerRect.vue






/* normalize component */

var LcChopCivicLikerRect_component = normalizeComponent(
  LcChopCivicLikerRect_LcChopCivicLikerRectvue_type_script_lang_js_,
  LcChopCivicLikerRectvue_type_template_id_7f8ef233_render,
  LcChopCivicLikerRectvue_type_template_id_7f8ef233_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LcChopCivicLikerRect = (LcChopCivicLikerRect_component.exports);
// CONCATENATED MODULE: ./src/components/LcChopCivicLikerRect/index.js


/* harmony default export */ var components_LcChopCivicLikerRect = (LcChopCivicLikerRect);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"27a05820-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/LcChopApproved/LcChopApproved.vue?vue&type=template&id=25a5b090&
var LcChopApprovedvue_type_template_id_25a5b090_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('lc-chop-simple',_vm._b({class:_vm.$options.name,attrs:{"text":"APPROVED"}},'lc-chop-simple',_vm.$attrs,false))}
var LcChopApprovedvue_type_template_id_25a5b090_staticRenderFns = []


// CONCATENATED MODULE: ./src/components/LcChopApproved/LcChopApproved.vue?vue&type=template&id=25a5b090&

// CONCATENATED MODULE: ./src/mixins/deprecated.js
/* harmony default export */ var deprecated = ({
  created: function created() {
    // eslint-disable-next-line no-console
    console.warn("[ui-vue] <".concat(this.$options.name, "/> will be removed in future release."));
  }
});
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/LcChopApproved/LcChopApproved.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//


/* harmony default export */ var LcChopApprovedvue_type_script_lang_js_ = ({
  name: "lc-chop-approved",
  components: {
    LcChopSimple: components_LcChopSimple
  },
  mixins: [deprecated]
});
// CONCATENATED MODULE: ./src/components/LcChopApproved/LcChopApproved.vue?vue&type=script&lang=js&
 /* harmony default export */ var LcChopApproved_LcChopApprovedvue_type_script_lang_js_ = (LcChopApprovedvue_type_script_lang_js_); 
// CONCATENATED MODULE: ./src/components/LcChopApproved/LcChopApproved.vue





/* normalize component */

var LcChopApproved_component = normalizeComponent(
  LcChopApproved_LcChopApprovedvue_type_script_lang_js_,
  LcChopApprovedvue_type_template_id_25a5b090_render,
  LcChopApprovedvue_type_template_id_25a5b090_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LcChopApproved = (LcChopApproved_component.exports);
// CONCATENATED MODULE: ./src/components/LcChopApproved/index.js


/* harmony default export */ var components_LcChopApproved = (LcChopApproved);
// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js?{"cacheDirectory":"node_modules/.cache/vue-loader","cacheIdentifier":"27a05820-vue-loader-template"}!./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/LcLoadingIndicator/LcLoadingIndicator.vue?vue&type=template&id=70a0def0&
var LcLoadingIndicatorvue_type_template_id_70a0def0_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var LcLoadingIndicatorvue_type_template_id_70a0def0_staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"lc-loading-indicator"},[_c('div',[_c('div'),_c('div'),_c('div')])])}]


// CONCATENATED MODULE: ./src/components/LcLoadingIndicator/LcLoadingIndicator.vue?vue&type=template&id=70a0def0&

// CONCATENATED MODULE: ./node_modules/cache-loader/dist/cjs.js??ref--12-0!./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib!./node_modules/cache-loader/dist/cjs.js??ref--0-0!./node_modules/vue-loader/lib??vue-loader-options!./src/components/LcLoadingIndicator/LcLoadingIndicator.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var LcLoadingIndicatorvue_type_script_lang_js_ = ({
  name: "lc-loading-indicator"
});
// CONCATENATED MODULE: ./src/components/LcLoadingIndicator/LcLoadingIndicator.vue?vue&type=script&lang=js&
 /* harmony default export */ var LcLoadingIndicator_LcLoadingIndicatorvue_type_script_lang_js_ = (LcLoadingIndicatorvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./src/components/LcLoadingIndicator/LcLoadingIndicator.vue?vue&type=style&index=0&lang=scss&
var LcLoadingIndicatorvue_type_style_index_0_lang_scss_ = __webpack_require__("5eb2");

// CONCATENATED MODULE: ./src/components/LcLoadingIndicator/LcLoadingIndicator.vue






/* normalize component */

var LcLoadingIndicator_component = normalizeComponent(
  LcLoadingIndicator_LcLoadingIndicatorvue_type_script_lang_js_,
  LcLoadingIndicatorvue_type_template_id_70a0def0_render,
  LcLoadingIndicatorvue_type_template_id_70a0def0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LcLoadingIndicator = (LcLoadingIndicator_component.exports);
// CONCATENATED MODULE: ./src/components/LcLoadingIndicator/index.js


/* harmony default export */ var components_LcLoadingIndicator = (LcLoadingIndicator);
// CONCATENATED MODULE: ./src/components/index.js







// CONCATENATED MODULE: ./src/index.js


/* harmony default export */ var src = (components_LikeCoinUI);

// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib.js
/* concated harmony reexport LcAvatar */__webpack_require__.d(__webpack_exports__, "LcAvatar", function() { return LcAvatar; });
/* concated harmony reexport LcChopSimple */__webpack_require__.d(__webpack_exports__, "LcChopSimple", function() { return LcChopSimple; });
/* concated harmony reexport LcChopCountdown */__webpack_require__.d(__webpack_exports__, "LcChopCountdown", function() { return LcChopCountdown; });
/* concated harmony reexport LcChopCivicLiker */__webpack_require__.d(__webpack_exports__, "LcChopCivicLiker", function() { return LcChopCivicLiker; });
/* concated harmony reexport LcChopCivicLikerRect */__webpack_require__.d(__webpack_exports__, "LcChopCivicLikerRect", function() { return LcChopCivicLikerRect; });
/* concated harmony reexport LcChopApproved */__webpack_require__.d(__webpack_exports__, "LcChopApproved", function() { return LcChopApproved; });
/* concated harmony reexport LcLoadingIndicator */__webpack_require__.d(__webpack_exports__, "LcLoadingIndicator", function() { return LcLoadingIndicator; });


/* harmony default export */ var entry_lib = __webpack_exports__["default"] = (src);



/***/ })

/******/ });
//# sourceMappingURL=ui-vue.common.js.map